export default [
    /*
    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "",
        "position": "",
        "name": "",
        "group": ["grading", "editing"],
        "filter": "dok", "fiction", "commercial", "animation", "musikvideo",
        "genre": "",
        "length": "",
        "year": "2018",
        "tasks": ["Colorist"],
        "description": "",
        "festivals": "",
        "press": [
            {
                "title": "",
                "url":  "",
            }
        ],
        "links": [
            {
                "title":  "",
                "url":    "",
                "type":   ""
            }
        ],
        "team": {
            "regie":    "",
            "camera":   "",
            "editing":  "",
            "producer": "",
            "cast":     "",
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  ""
                },
            ]
        },
        "videos": {
            "video": [
                {
                    "title": "",
                    "url":  ""
                }
            ]
        }
    },

     */



    // Next free ID 74


        // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //


        {
            "id": "73",
            "position": "",
            "name": "Schlafende Hunde",
            "group": ["editing"],
            "filter": "fiction",
            "genre": "Netflix Serie",
            "length": "6 Folgen",
            "year": "2022",
            "tasks": ["Additional Editor"],
            "description": "Ein abgestürzter Top-Polizist und eine aufstrebende junge Staatsanwältin öffnen aus unterschiedlichen Motiven eine geschlossene Mordakte – und damit die Büchse der Pandora. Beide geraten auf die blutige Fährte einer Verschwörung, die immer tiefer in Polizei und Justiz zu führen scheint. Oder hängt alles mit einem Terroranschlag zusammen, der die Stadt vor anderthalb Jahren erschüttert hat?",
            "festivals": "",
            "press": [
                {
                    "title": "",
                    "url":  "",
                }
            ],
            "links": [
                {
                    "title":  "",
                    "url":    "",
                    "type":   ""
                }
            ],
            "team": {
                "regie":    "Stephan Lacant und Francis Meletzky",
                "camera":   "Jens Harant, Bella Halben",
                "editing":  "Piet Schmelz, Katja Fischer, Martin Wolf",
                "producer": "Real Film Berlin GmbH",
                "cast":     "Max Riemelt, Luise von Finckh, Carlo Ljubek, Antonio Wannek, Melodie Wakivuamina, Helgi Schmid, Peri Baumeister",
                "showrunner": "Henning Kamm und Sibylle Stellbrink"
            },
            "images": {
                "image": [
                    {
                        "title": "",
                        "url":  "schlafende-hunde-002.jpg"
                    },
                ]
            },
            "videos": {
                "video": [
                    {
                        "title": "",
                        "url":  ""
                    }
                ]
            }
        },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //


    {
        "id": "72",
        "position": "",
        "name": "KLEO",
        "group": ["editing"],
        "filter": "fiction",
        "genre": "Netflix Serie",
        "length": "8 Folgen",
        "year": "2021",
        "tasks": ["Additional Editor"],
        "description": "1987: Nach dem Fall der Mauer möchte eine ostdeutsche Ex-Spionin herausfinden, wer sie verraten hat und warum, wobei sie ihre tödliche Ausbildung hervorragend einsetzen kann,",
        "festivals": "",
        "press": [
            {
                "title": "Drehstart",
                "url":  "https://www.serienjunkies.de/news/kleo-infos-deutschen-netflix-serie-107946.html",
            }
        ],
        "links": [
            {
                "title":  "",
                "url":    "",
                "type":   ""
            }
        ],
        "team": {
            "regie":    "Viviane Andereggen und Jano Ben Chaabane",
            "camera":   "",
            "editing":  "Piet Schmelz, Katja Fischer, Felix Rudek, Constantin von Seld",
            "producer": "Zeitsprung Pictures GmbH",
            "cast":     "Jella Haase, Dimitrij Schaad, Vladimir Burlakov, Thandi Sebe, Marta Sroka, Julius Feldmeier und Jürgen Heinrich",
            "showrunner": "Hanno Hackfort, Bob Konrad, Richard Kropf"
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "kleo-001.jpg"
                },
            ]
        },
        "videos": {
            "video": [
                {
                    "title": "",
                    "url":  ""
                }
            ]
        }
    },


    {
        "id": "71",
        "position": "",
        "name": "KITZ",
        "group": ["editing"],
        "filter": "fiction",
        "genre": "Netflix Serie",
        "length": "6 Folgen",
        "year": "2021",
        "tasks": ["Assistant Editor"],
        "description": "Ein Jahr nach dem tragischen Tod ihres Bruders dringt die 19-jährige Kitzbühelerin Lisi in die dekadente Welt einer Münchner Clique ein, die jede Saison in den Nobelskiort zum Feiern einfällt." +
            "Doch schon bald tritt Lisi eine Lawine los, die die Wahrheit hinter der Fassade voller Glamour, Geld und Hedonismus zum Vorschein bringt – mit unkontrollierbaren Folgen.",
        "festivals": "",
        "press": [
            {
                "title": "",
                "url":  "",
            }
        ],
        "links": [
            {
                "title":  "",
                "url":    "",
                "type":   ""
            }
        ],
        "team": {
            "regie":    "Lea Becker, Maurice Hübner",
            "camera":   "",
            "editing":  "Boris Gromatzki, Carolin Biesenbach, Katja Fischer, Till Ufer",
            "producer": "Odeon Fiction GmbH",
            "cast":     "Sofie Eifertinger, Valerie Huber, Bless Amada, Krista Tcherneva, Ben Felipe, Zoran Pingel",
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "kitz-001.jpg"
                },
            ]
        },
        "videos": {
            "video": [
                {
                    "title": "",
                    "url":  ""
                }
            ]
        }
    },



    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "70",
        "position": "",
        "name": "Der grosse Fake - Die Wirecard Story",
        "group": ["editing"],
        "filter": "fiction",
        "genre": "Doku-Thriller",
        "length": "90 Min",
        "year": "2021",
        "tasks": ["Assistant Editor"],
        "description": "",
        "festivals": "",
        "press": [
            {
                "title": "",
                "url":  "",
            }
        ],
        "links": [
            {
                "title":  "",
                "url":    "",
                "type":   ""
            }
        ],
        "team": {
            "regie":    "",
            "camera":   "",
            "editing":  "",
            "producer": "",
            "cast":     "",
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "wirecard-005.jpg"
                },
                {
                    "title": "",
                    "url":  "wirecard-001.jpg"
                },
                {
                    "title": "",
                    "url":  "wirecard-003.jpg"
                },
                {
                    "title": "",
                    "url":  "wirecard-004.jpg"
                },
                {
                    "title": "",
                    "url":  "wirecard-006.jpg"
                },
                {
                    "title": "",
                    "url":  "wirecard-007.jpg"
                },
                {
                    "title": "",
                    "url":  "wirecard-008.jpg"
                },
            ]
        },
        "videos": {
            "video": [
                {
                    "title": "",
                    "url":  ""
                }
            ]
        }
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "75",
        "position": "",
        "name": "Tom Tailor",
        "group": ["grading"],
        "filter": "commercial",
        "genre": "Werbung",
        "length": "3 Spots",
        "year": "2021",
        "tasks": ["Colorist"],
        "description": "",
        "festivals": "",
        "press": [
            {
                "title": "",
                "url":  "",
            }
        ],
        "links": [
            {
                "title":  "",
                "url":    "",
                "type":   ""
            }
        ],
        "team": {
            "regie":    "",
            "camera":   "",
            "editing":  "",
            "producer": "",
            "cast":     "",
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "tomtailor-001.jpg"
                },
                {
                    "title": "",
                    "url":  "tomtailor-002.jpg"
                },
                {
                    "title": "",
                    "url":  "tomtailor-003.jpg"
                },
                {
                    "title": "",
                    "url":  "tomtailor-004.jpg"
                },
                {
                    "title": "",
                    "url":  "tomtailor-005.jpg"
                },
                {
                    "title": "",
                    "url":  "tomtailor-006.jpg"
                },
                {
                    "title": "",
                    "url":  "tomtailor-007.jpg"
                }
            ]
        },
        "videos": {
            "video": [
                {
                    "title": "",
                    "url":  ""
                }
            ]
        }
    },


    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //


    {
        "id": "74",
        "position": "",
        "name": "Buffalo Runner",
        "group": ["grading"],
        "filter": "dok",
        "genre": "Dok Short",
        "length": "7 Min",
        "year": "2021",
        "tasks": ["Colorist"],
        "description": "Growing up on an Indian reservation Duane Kemmer took to alcohol, getting into fights with everyone and his dog. 10 years ago he stopped to never touch a drop again. He now runs an Indian Relay team with his family.",
        "festivals": "",
        "press": [
            {
                "title": "",
                "url":  "",
            }
        ],
        "links": [
            {
                "title":  "",
                "url":    "",
                "type":   ""
            }
        ],
        "team": {
            "regie":    "Thilo Gundelach",
            "camera":   "Leonhard Kaufmann",
            "editing":  "Thilo Gundelach",
            "producer": "",
            "cast":     "Duane Kemmer, Narsis Reevis,Cliff Kemmer",
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "buffalo-runner-001.jpg"
                },
                {
                    "title": "",
                    "url":  "buffalo-runner-002.jpg"
                },
                {
                    "title": "",
                    "url":  "buffalo-runner-003.jpg"
                },
                {
                    "title": "",
                    "url":  "buffalo-runner-004.jpg"
                },
                {
                    "title": "",
                    "url":  "buffalo-runner-005.jpg"
                }
            ]
        },
        "videos": {
            "video": [
                {
                    "title": "",
                    "url":  ""
                }
            ]
        }
    },
    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //


    {
        "id": "69",
        "position": "",
        "name": "Wild Republic",
        "group": ["editing"],
        "filter": "fiction",
        "genre": "Magenta-TV Serie",
        "length": "8 Episoden",
        "year": "2020",
        "tasks": ["Assistant Editor"],
        "description": "Wild Republic ist eine deutsche Abenteuerserie von Magenta TV und handelt von einer Gruppe junger Sträflinge, die in die Wildnis flüchten und dort ihren eigenen Staat gründen.",
        "festivals": "",
        "press": [
            {
                "title": "",
                "url":  "",
            }
        ],
        "links": [
            {
                "title":  "Trailer",
                "url":    "https://www.youtube.com/watch?v=OPl72w0vyRo",
                "type":   ""
            }
        ],
        "team": {
            "regie":    "Markus Goller und Lennart Ruff",
            "camera":   "",
            "editing":  "Carolin Biesenbach, Katja Fischer, Piet Schmelz",
            "producer": "Lailaps Pictures, X Filme Creative Pool",
            "cast":     "Franz Hartwig, Verena Altenberger, Emma Drogunova, Merlin Rose, Maria Dragus, Béla Lenz, Rouven Israel, Aaron Altaras, Camille Dombrowsky, Luna Jordan, Anand Batbileg",
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "wild-republic-001.jpg"
                },
            ]
        },
        "videos": {
            "video": [
                {
                    "title": "",
                    "url":  ""
                }
            ]
        }
    },



    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //


    {
        "id": "73",
        "position": "",
        "name": "Telekom - Home Office",
        "group": ["editing"],
        "filter": "commercial",
        "genre": "Werbung",
        "length": "20 Sek",
        "year": "2020",
        "tasks": ["Editor"],
        "description": "",
        "festivals": "",
        "press": [
            {
                "title": "",
                "url":  "",
            }
        ],
        "links": [
            {
                "title":  "",
                "url":    "",
                "type":   ""
            }
        ],
        "team": {
            "regie":    "",
            "camera":   "",
            "editing":  "",
            "producer": "",
            "cast":     "",
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "telekom-homeoffice-001.jpg"
                },
                {
                    "title": "",
                    "url":  "telekom-homeoffice-002.jpg"
                },
            ]
        },
        "videos": {
            "video": [
                {
                    "title": "",
                    "url":  ""
                }
            ]
        }
    },


// - - - - - - - - - - - - - - - - - - - - - - - - - - - - //


    {
        "id": "52",
        "position": "",
        "name": "Color Showreel",
        "group": ["grading", "showreel"],
        "filter": "showreel",
        "genre": "Showreel",
        "length": "2 Min",
        "year": "2018-2019",
        "tasks": "",
        "description": "Mein aktuelles Colorgrading Showreel mit Projekten aus dem Zeitraum 2016 - 2018.",
        "festivals": "",

        "videos": {
            "video": [
                {
                    "title": "",
                    "url":  "grading-showreel-2018.webm"
                }
            ]
        }
    },


    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "61",
        "position": "",
        "name": "Hella Gravity",
        "group": ["grading"],
        "filter": "commercial",
        "genre": "Werbung",
        "length": "1 Min",
        "year": "2020",
        "tasks": ["Colorist"],
        "description": "",
        "festivals": "",

        "links": {
            "link": {
                "title":  "",
                "url":    "",
                "type":   ""
            }
        },
        "team": {
            "regie":        "Tarek Roehlinger",
            "camera":       "Nikolaus Schreiber",
            "editing":      "Bela Adami",
            "sounddesign":  "",
            "producer":     "Kojotenfilm Produktion",
            "cast":         "",
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "hella-gravity-001.jpg"
                },
                {
                    "title": "",
                    "url":  "hella-gravity-002.jpg"
                },
                {
                    "title": "",
                    "url":  "hella-gravity-003.jpg"
                },
                {
                    "title": "",
                    "url":  "hella-gravity-004.jpg"
                },
                {
                    "title": "",
                    "url":  "hella-gravity-005.jpg"
                },
                {
                    "title": "",
                    "url":  "hella-gravity-006.jpg"
                },
                {
                    "title": "",
                    "url":  "hella-gravity-007.jpg"
                },
                {
                    "title": "",
                    "url":  "hella-gravity-008.jpg"
                },
                {
                    "title": "",
                    "url":  "hella-gravity-009.jpg"
                },
                {
                    "title": "",
                    "url":  "hella-gravity-010.jpg"
                },
                {
                    "title": "",
                    "url":  "hella-gravity-011.jpg"
                }

            ]
        }
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "62",
        "position": "",
        "name": "Mein fremdes Land",
        "group": ["grading"],
        "filter": "dok",
        "genre": "Dokumentarfilm",
        "length": "90 Min",
        "year": "2020",
        "tasks": ["Colorist"],
        "description": "",
        "festivals": "",

        "links": {
            "link": {
                "title":  "",
                "url":    "",
                "type":   ""
            }
        },
        "team": {
            "regie":        "Johannes Preuss",
            "camera":       "Johannes Preuss",
            "editing":      "Tobias Wilhelmer",
            "sounddesign":  "Marvin Keil, Claudio Demel",
            "producer":     "Marius Brüning, Malte Schumacher",
            "cast":         "",
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "return-to-potosi-001.jpg"
                },
                {
                    "title": "",
                    "url":  "return-to-potosi-002.jpg"
                },
                {
                    "title": "",
                    "url":  "return-to-potosi-003.jpg"
                },
                {
                    "title": "",
                    "url":  "return-to-potosi-004.jpg"
                },
                {
                    "title": "",
                    "url":  "return-to-potosi-005.jpg"
                },
                {
                    "title": "",
                    "url":  "return-to-potosi-006.jpg"
                },
                {
                    "title": "",
                    "url":  "return-to-potosi-007.jpg"
                },
                {
                    "title": "",
                    "url":  "return-to-potosi-008.jpg"
                },
                {
                    "title": "",
                    "url":  "return-to-potosi-009.jpg"
                },
                {
                    "title": "",
                    "url":  "return-to-potosi-010.jpg"
                },
                {
                    "title": "",
                    "url":  "return-to-potosi-011.jpg"
                },
                {
                    "title": "",
                    "url":  "return-to-potosi-012.jpg"
                },
                {
                    "title": "",
                    "url":  "return-to-potosi-013.jpg"
                },
                {
                    "title": "",
                    "url":  "return-to-potosi-014.jpg"
                },
                {
                    "title": "",
                    "url":  "return-to-potosi-015.jpg"
                },
                {
                    "title": "",
                    "url":  "return-to-potosi-016.jpg"
                },
                {
                    "title": "",
                    "url":  "return-to-potosi-017.jpg"
                },
                {
                    "title": "",
                    "url":  "return-to-potosi-018.jpg"
                },
                {
                    "title": "",
                    "url":  "return-to-potosi-019.jpg"
                },
                {
                    "title": "",
                    "url":  "return-to-potosi-020.jpg"
                },
                {
                    "title": "",
                    "url":  "return-to-potosi-021.jpg"
                },
                {
                    "title": "",
                    "url":  "return-to-potosi-022.jpg"
                },
                {
                    "title": "",
                    "url":  "return-to-potosi-023.jpg"
                }
            ]
        }
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "60",
        "position": "",
        "name": "A Portrait on the Search for Happiness",
        "group": ["editing"],
        "filter": "dok",
        "genre": "Dokumentarfilm",
        "length": "72 Min",
        "year": "2020",
        "tasks": ["Editor"],
        "description": "Eine riesige südafrikanische Wüste, dahinter ein tiefes, kaltes Meer: Hier graben Hunderte von jungen Männern nach den reinsten Diamanten der Welt. Eine poetische Reise durch Wüste, Wind und Sand.",
        "festivals": "54. Hoferfilmtage, One World International Human Rights Festival, DokFest München, 50th Kyiv International Molodist, 23rd Encounters South African International Documentary Festival",

        "links": {
            "link": {
                "title":  "",
                "url":    "",
                "type":   ""
            }
        },
        "team": {
            "regie":        "Benny Rost",
            "camera":       "Johannes Greisle",
            "editing":      "",
            "sounddesign":  "",
            "producer":     "Mark Szilagyi, Estella Suplit",
            "cast":         "",
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "posh-007.jpg"
                },
                {
                    "title": "",
                    "url":  "posh-001.jpg"
                },
                {
                    "title": "",
                    "url":  "posh-002.jpg"
                },
                {
                    "title": "",
                    "url":  "posh-003.jpg"
                },
                {
                    "title": "",
                    "url":  "posh-004.jpg"
                },
                {
                    "title": "",
                    "url":  "posh-005.jpg"
                },
                {
                    "title": "",
                    "url":  "posh-006.jpg"
                },
                {
                    "title": "",
                    "url":  "posh-008.jpg"
                },
                {
                    "title": "",
                    "url":  "posh-009.jpg"
                },
                {
                    "title": "",
                    "url":  "posh-010.jpg"
                },
                {
                    "title": "",
                    "url":  "posh-011.jpg"
                },
                {
                    "title": "",
                    "url":  "posh-012.jpg"
                },
                {
                    "title": "",
                    "url":  "posh-013.jpg"
                },
                {
                    "title": "",
                    "url":  "posh-014.jpg"
                },
                {
                    "title": "",
                    "url":  "posh-015.jpg"
                },
                {
                    "title": "",
                    "url":  "posh-016.jpg"
                },
                {
                    "title": "",
                    "url":  "posh-017.jpg"
                },
                {
                    "title": "",
                    "url":  "posh-018.jpg"
                }
            ]
        }
    },


    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "68",
        "position": "",
        "name": "Waid",
        "group": ["grading", "editing"],
        "filter": "fiction",
        "genre": "Kurzfilm",
        "length": "18 Min",
        "year": "2020",
        "tasks": ["Editor", "Colorist"],
        "description": "The parents of the silent Felix are passionate hunters. Not only in the hunting ground, but also at home they keep order with a firm hand. But can that what disturbs the peace of the forest be tamed with rules or does the parents' plan drive the whole family into gloom.",
        "festivals": "",

        "links": {
            "link": {
                "title":  "",
                "url":    "",
                "type":   ""
            }
        },
        "team": {
            "regie":        "Lorenz Piehl",
            "camera":       "Maciej Rolbiecki",
            "editing":      "",
            "sounddesign":  "Claudio Demel",
            "producer":     "Giganten Film",
            "cast":         "Jonathan Lade, Anette Mayer, Martin Wangler",
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "waid-014.jpg"
                },
                {
                    "title": "",
                    "url":  "waid-001.jpg"
                },
                {
                    "title": "",
                    "url":  "waid-002.jpg"
                },
                {
                    "title": "",
                    "url":  "waid-003.jpg"
                },
                {
                    "title": "",
                    "url":  "waid-004.jpg"
                },
                {
                    "title": "",
                    "url":  "waid-005.jpg"
                },
                {
                    "title": "",
                    "url":  "waid-006.jpg"
                },
                {
                    "title": "",
                    "url":  "waid-007.jpg"
                },
                {
                    "title": "",
                    "url":  "waid-008.jpg"
                },
                {
                    "title": "",
                    "url":  "waid-009.jpg"
                },
                {
                    "title": "",
                    "url":  "waid-010.jpg"
                },
                {
                    "title": "",
                    "url":  "waid-011.jpg"
                },
                {
                    "title": "",
                    "url":  "waid-012.jpg"
                },
                {
                    "title": "",
                    "url":  "waid-013.jpg"
                },
                {
                    "title": "",
                    "url":  "waid-015.jpg"
                }

            ]
        }
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "63",
        "position": "",
        "name": "Mercedes - What moves you",
        "group": ["grading"],
        "filter": "commercial",
        "genre": "Werbung",
        "length": "2 Min",
        "year": "2020",
        "tasks": ["Colorist"],
        "description": "",
        "festivals": "",

        "links": {
            "link": {
                "title":  "",
                "url":    "",
                "type":   ""
            }
        },
        "team": {
            "regie":        "Marta Trela",
            "camera":       "Jonas Schneider",
            "editing":      "",
            "sounddesign":  "",
            "producer":     "",
            "cast":         "",
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "what-moves-you-008.jpg"
                },
                {
                    "title": "",
                    "url":  "what-moves-you-001.jpg"
                },
                {
                    "title": "",
                    "url":  "what-moves-you-002.jpg"
                },
                {
                    "title": "",
                    "url":  "what-moves-you-003.jpg"
                },
                {
                    "title": "",
                    "url":  "what-moves-you-004.jpg"
                },
                {
                    "title": "",
                    "url":  "what-moves-you-005.jpg"
                },
                {
                    "title": "",
                    "url":  "what-moves-you-006.jpg"
                },
                {
                    "title": "",
                    "url":  "what-moves-you-007.jpg"
                },
                {
                    "title": "",
                    "url":  "what-moves-you-009.jpg"
                }

            ]
        }
    },


    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "64",
        "position": "",
        "name": "Brother - Don't",
        "group": ["grading"],
        "filter": "commercial",
        "genre": "Werbung",
        "length": "2 Min",
        "year": "2020",
        "tasks": ["Colorist"],
        "description": "",
        "festivals": "",

        "links": {
            "link": {
                "title":  "",
                "url":    "",
                "type":   ""
            }
        },
        "team": {
            "regie":        "Hanna Seidel",
            "camera":       "Marvin Schatz",
            "editing":      "Andrea Grumbt",
            "sounddesign":  "Denis Elmaci",
            "producer":     "Kojotenfilm Produktion",
            "cast":         "",
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "brother-dont-001.jpg"
                },
                {
                    "title": "",
                    "url":  "brother-dont-002.jpg"
                },
                {
                    "title": "",
                    "url":  "brother-dont-003.jpg"
                },
                {
                    "title": "",
                    "url":  "brother-dont-004.jpg"
                },
                {
                    "title": "",
                    "url":  "brother-dont-005.jpg"
                },
                {
                    "title": "",
                    "url":  "brother-dont-006.jpg"
                },
                {
                    "title": "",
                    "url":  "brother-dont-007.jpg"
                },
                {
                    "title": "",
                    "url":  "brother-dont-008.jpg"
                }

            ]
        }
    },


    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "67",
        "position": "",
        "name": "Brother - Tattoo",
        "group": ["grading"],
        "filter": "commercial",
        "genre": "Werbung",
        "length": "2 Min",
        "year": "2020",
        "tasks": ["Colorist"],
        "description": "",
        "festivals": "",

        "links": {
            "link": {
                "title":  "",
                "url":    "",
                "type":   ""
            }
        },
        "team": {
            "regie":        "Hanna Seidel",
            "camera":       "Marvin Schatz",
            "editing":      "Tobias Wilhelmer",
            "sounddesign":  "Denis Elmaci",
            "producer":     "Kojotenfilm Produktion",
            "cast":         "",
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "brother-tattoo-002.jpg"
                },
                {
                    "title": "",
                    "url":  "brother-tattoo-001.jpg"
                },
                {
                    "title": "",
                    "url":  "brother-tattoo-003.jpg"
                },
                {
                    "title": "",
                    "url":  "brother-tattoo-004.jpg"
                },
                {
                    "title": "",
                    "url":  "brother-tattoo-005.jpg"
                }

            ]
        }
    },


    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "65",
        "position": "",
        "name": "Friedemann Vogel - Verkörperung des Tanzes",
        "group": ["grading"],
        "filter": "dok",
        "genre": "Dokumentarfilm",
        "length": "60 Min",
        "year": "2020",
        "tasks": ["Colorist"],
        "description": "Friedemann Vogel, Erster Solist des Stuttgarter Balletts, hat die bedeutendsten Ballettbühnen der Welt erobert. An der Seite der Primaballerinen des 21. Jahrhunderts begeistert er das heimische wie das internationale Publikum. Ein deutscher Tänzer an der Spitze der Ballettwelt -| eine absolute Rarität. Der dokumentarische Porträtfilm von Katja Trautwein begleitet den Tänzer in seinem Alltag ausgehend vom Stuttgarter Ballett über Berlin, Stockholm und Moskau bis nach Tokio.",
        "festivals": "",

        "links": {
            "link": {
                "title":  "",
                "url":    "",
                "type":   ""
            }
        },
        "team": {
            "regie":        "Katja Trautwein",
            "camera":       "Feline Gerhardt, Farina Hasak, Gerry Sonneborn",
            "editing":      "Farina Hasak",
            "sounddesign":  "Paul Powaljaew, Volker Armbruster",
            "producer":     "Katja Trautwein",
            "cast":         "",
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "friedemann-vogel-001.jpg"
                },
                {
                    "title": "",
                    "url":  "friedemann-vogel-002.jpg"
                },
                {
                    "title": "",
                    "url":  "friedemann-vogel-003.jpg"
                },
                {
                    "title": "",
                    "url":  "friedemann-vogel-004.jpg"
                },
                {
                    "title": "",
                    "url":  "friedemann-vogel-005.jpg"
                },
                {
                    "title": "",
                    "url":  "friedemann-vogel-006.jpg"
                },
                {
                    "title": "",
                    "url":  "friedemann-vogel-007.jpg"
                },
                {
                    "title": "",
                    "url":  "friedemann-vogel-008.jpg"
                },
                {
                    "title": "",
                    "url":  "friedemann-vogel-009.jpg"
                },
                {
                    "title": "",
                    "url":  "friedemann-vogel-010.jpg"
                },
                {
                    "title": "",
                    "url":  "friedemann-vogel-011.jpg"
                }

            ]
        }
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //


    {
        "id": "66",
        "position": "",
        "name": "Hella - Crying Men",
        "group": ["grading"],
        "filter": "commercial",
        "genre": "Werbung",
        "length": "2 Min",
        "year": "2020",
        "tasks": ["Colorist"],
        "description": "",
        "festivals": "",

        "links": {
            "link": {
                "title":  "",
                "url":    "",
                "type":   ""
            }
        },
        "team": {
            "regie":        "Tarek Roehlinger",
            "camera":       "Julian C. Steiner",
            "editing":      "Bela Adami",
            "sounddesign":  "Denis Elmaci",
            "producer":     "Kojotenfilm Produktion",
            "cast":         "",
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "hella-crying-men-006.jpg"
                },
                {
                    "title": "",
                    "url":  "hella-crying-men-001.jpg"
                },
                {
                    "title": "",
                    "url":  "hella-crying-men-002.jpg"
                },
                {
                    "title": "",
                    "url":  "hella-crying-men-003.jpg"
                },
                {
                    "title": "",
                    "url":  "hella-crying-men-004.jpg"
                },
                {
                    "title": "",
                    "url":  "hella-crying-men-005.jpg"
                },
                {
                    "title": "",
                    "url":  "hella-crying-men-007.jpg"
                },
                {
                    "title": "",
                    "url":  "hella-crying-men-008.jpg"
                }
            ]
        }
    },



    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "46",
        "position": "",
        "name": "Show Yourself",
        "group": ["grading"],
        "filter": "commercial",
        "genre": "Werbung",
        "length": "3 Min",
        "year": "2019",
        "tasks": ["Colorist"],
        "description": "Ein Film über einen universellen Konflikt - zerrissen zu werden von dem, was man für richtig hält und was man gesagt bekommt, was falsch ist.\n" +
            "Ein Film, der sich auf die Reise konzentriert. Ein Zustand der Unsicherheit. \n" +
            "Ein seltener Moment der Klarheit - man weiß einfach, was richtig ist.",
        "festivals": "",
        "links": [
            {
                "title":  "Horizont Artikel",
                "url":    "https://www.horizont.net/agenturen/auftritte-des-tages/filmakademie-baden-wuerttemberg-der-grossartige-levis-kurzfilm-von-regietalent-thilo-gundelach-178545?fbclid=IwAR3SH2jSSomv4CQn183kNW5slBxiJahOucoT9MrSdxlwBhBmVMWK2-cRhKk",
                "type":   ""
            },
            {
                "title":  "Shots Artikel",
                "url":    "https://shots.net/news/view/what-does-it-take-to-show-yourself?fbclid=IwAR2VHC2BUtDe7l9LuJZr6WzZewB3RMM10VJek3u05snBpHNtpESUR1wHdPQ",
                "type":   ""
            }
        ],
        "team": {
            "regie":    "Thilo Gundelach",
            "camera":   "Jonas Schneider",
            "editing":  "David Kuruc",
            "producer": "Felix Antretter, Lili Färberböck, Stefanie Goedicke",
            "sounddesign":  "Jan Brett",
            "cast":     "Judson Michael Stalter, Steffan Argus",
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "show-yourself-001.jpg"
                },
                {
                    "title": "",
                    "url":  "show-yourself-002.jpg"
                },
                {
                    "title": "",
                    "url":  "show-yourself-003.jpg"
                },
                {
                    "title": "",
                    "url":  "show-yourself-004.jpg"
                },
                {
                    "title": "",
                    "url":  "show-yourself-005.jpg"
                },
                {
                    "title": "",
                    "url":  "show-yourself-006.jpg"
                },
                {
                    "title": "",
                    "url":  "show-yourself-007.jpg"
                },
                {
                    "title": "",
                    "url":  "show-yourself-008.jpg"
                },
                {
                    "title": "",
                    "url":  "show-yourself-009.jpg"
                },
                {
                    "title": "",
                    "url":  "show-yourself-010.jpg"
                },
                {
                    "title": "",
                    "url":  "show-yourself-011.jpg"
                },
                {
                    "title": "",
                    "url":  "show-yourself-012.jpg"
                },
                {
                    "title": "",
                    "url":  "show-yourself-013.jpg"
                },
                {
                    "title": "",
                    "url":  "show-yourself-014.jpg"
                },
                {
                    "title": "",
                    "url":  "show-yourself-015.jpg"
                }
            ]
        }
    },


    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //


    {
        "id": "58",
        "position": "",
        "name": "Fünf nach Zwölf",
        "group": ["grading"],
        "filter": "fiction",
        "genre": "Fiction",
        "length": "40 Min",
        "year": "2019",
        "tasks": ["Colorist"],
        "description": "",
        "festivals": "",

        "links": {
            "link": {
                "title":  "",
                "url":    "",
                "type":   ""
            }
        },
        "team": {
            "regie":        "Tarek Röhlinger",
            "camera":       "Rafael Starman",
            "editing":      "Tobias Wieduwilt",
            "sounddesign":  "",
            "producer":     "Magda Wolff",
            "cast":         "",
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "fuenf-nach-zwoelf-012.jpg"
                },
                {
                    "title": "",
                    "url":  "fuenf-nach-zwoelf-002.jpg"
                },
                {
                    "title": "",
                    "url":  "fuenf-nach-zwoelf-003.jpg"
                },
                {
                    "title": "",
                    "url":  "fuenf-nach-zwoelf-004.jpg"
                },
                {
                    "title": "",
                    "url":  "fuenf-nach-zwoelf-005.jpg"
                },
                {
                    "title": "",
                    "url":  "fuenf-nach-zwoelf-006.jpg"
                },
                {
                    "title": "",
                    "url":  "fuenf-nach-zwoelf-007.jpg"
                },
                {
                    "title": "",
                    "url":  "fuenf-nach-zwoelf-008.jpg"
                },
                {
                    "title": "",
                    "url":  "fuenf-nach-zwoelf-009.jpg"
                },
                {
                    "title": "",
                    "url":  "fuenf-nach-zwoelf-010.jpg"
                },
                {
                    "title": "",
                    "url":  "fuenf-nach-zwoelf-011.jpg"
                },
                {
                    "title": "",
                    "url":  "fuenf-nach-zwoelf-013.jpg"
                },
                {
                    "title": "",
                    "url":  "fuenf-nach-zwoelf-014.jpg"
                },
                {
                    "title": "",
                    "url":  "fuenf-nach-zwoelf-015.jpg"
                },
                {
                    "title": "",
                    "url":  "fuenf-nach-zwoelf-001.jpg"
                },
            ]
        }
    },


    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "57",
        "position": "",
        "name": "Temple of Eternity",
        "group": ["grading"],
        "filter": "commercial",
        "genre": "Werbung",
        "length": "2 Min",
        "year": "2019",
        "tasks": ["Colorist"],
        "description": "Miranda entdeckt in einer verlassenen Fabrikhalle eine alte Schneiderin. Sie bringt ihr Nähen bei und lässt sie somit ihren Kummer und ihre Sorgen vergessen. Doch in Wahrheit ist sie selbst die Schneiderin.",
        "festivals": "",

        "links": {
            "link": {
                "title":  "Herstellerseite",
                "url":    "https://blog.bernina.com/de/2020/01/temple-of-eternity-naehmaschine/",
                "type":   ""
            }
        },
        "team": {
            "regie":        "Gabriel Becker",
            "camera":       "Tim Weskamp",
            "editing":      "Frauke Tietjen",
            "sounddesign":  "Marco Dahl",
            "producer":     "Tobias Lischka",
            "cast":         "",
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "temple-of-eternity-001.jpg"
                },
                {
                    "title": "",
                    "url":  "temple-of-eternity-002.jpg"
                },
                {
                    "title": "",
                    "url":  "temple-of-eternity-003.jpg"
                },
                {
                    "title": "",
                    "url":  "temple-of-eternity-004.jpg"
                },
                {
                    "title": "",
                    "url":  "temple-of-eternity-005.jpg"
                },
                {
                    "title": "",
                    "url":  "temple-of-eternity-006.jpg"
                },
                {
                    "title": "",
                    "url":  "temple-of-eternity-007.jpg"
                },
                {
                    "title": "",
                    "url":  "temple-of-eternity-008.jpg"
                },
                {
                    "title": "",
                    "url":  "temple-of-eternity-010.jpg"
                },
                {
                    "title": "",
                    "url":  "temple-of-eternity-011.jpg"
                },
                {
                    "title": "",
                    "url":  "temple-of-eternity-012.jpg"
                },
                {
                    "title": "",
                    "url":  "temple-of-eternity-013.jpg"
                },
                {
                    "title": "",
                    "url":  "temple-of-eternity-014.jpg"
                },
                {
                    "title": "",
                    "url":  "temple-of-eternity-015.jpg"
                }
            ]
        }
    },


    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "59",
        "position": "",
        "name": "Männerabend",
        "group": ["grading"],
        "filter": "fiction",
        "genre": "Kurzfilm",
        "length": "30 Min",
        "year": "2019",
        "tasks": ["Colorist"],
        "description": "",
        "festivals": "",

        "links": {
            "link": {
                "title":  "",
                "url":    "",
                "type":   ""
            }
        },
        "team": {
            "regie":        "Ares Ceylan",
            "camera":       "Bo-Christian Riedel-Petzold",
            "editing":      "",
            "sounddesign":  "",
            "producer":     "Maximilian Greil",
            "cast":         "",
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "maennerabend-001.jpg"
                },
                {
                    "title": "",
                    "url":  "maennerabend-002.jpg"
                },
                {
                    "title": "",
                    "url":  "maennerabend-003.jpg"
                },
                {
                    "title": "",
                    "url":  "maennerabend-004.jpg"
                },
                {
                    "title": "",
                    "url":  "maennerabend-005.jpg"
                },
                {
                    "title": "",
                    "url":  "maennerabend-006.jpg"
                },
                {
                    "title": "",
                    "url":  "maennerabend-007.jpg"
                },
                {
                    "title": "",
                    "url":  "maennerabend-008.jpg"
                },
                {
                    "title": "",
                    "url":  "maennerabend-009.jpg"
                },
                {
                    "title": "",
                    "url":  "maennerabend-010.jpg"
                },
                {
                    "title": "",
                    "url":  "maennerabend-012.jpg"
                },
                {
                    "title": "",
                    "url":  "maennerabend-013.jpg"
                },
                {
                    "title": "",
                    "url":  "maennerabend-014.jpg"
                }
            ]
        }
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "51",
        "position": "",
        "name": "6Min66",
        "group": ["grading"],
        "filter": "dok",
        "genre": "Dokumentarfilm",
        "length": "60 Min",
        "year": "2019",
        "tasks": ["Colorist"],
        "description": "Stirbt der Ort Kino, stirbt das Kino als Kunstform?\n" +
            "6Minuten66 ist ein Experiment. Regisseur*innen werden in einem Hotelzimmer mit Fragen zur Zukunft des Kinos und zwei Kameras alleingelassen. Sie haben 6 Minuten und 66 Sekunden Zeit sich zu verhalten.",
        "festivals": "",

        "team": {
            "regie":    "Julius Feldmeier, Katja Feldmeier",
            "camera":   "Moritz Schultheiß",
            "editing":  "",
            "producer": "TriebKraft Film",
            "cast":     "Thomas Stuber, Mia Spengler, Katrin Gebbe, Axel Ranisch, Burhan Qubani, Tom Lass, Dietrich Brüggemann, Laura Lackmann, Christian Schwochow, Sonja Heiss, Cüneyt Kaya, Tini Tüllmann, Helene Hegeman, Nikias Chryssos & Jakob Lass",
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "6min66-001.jpg"
                },
                {
                    "title": "",
                    "url":  "6min66-002.jpg"
                },
                {
                    "title": "",
                    "url":  "6min66-003.jpg"
                },
                {
                    "title": "",
                    "url":  "6min66-004.jpg"
                },
                {
                    "title": "",
                    "url":  "6min66-005.jpg"
                }
            ]
        }
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "53",
        "position": "",
        "name": "Jobcenter Stuttgart",
        "group": ["editing", "grading"],
        "filter": "commercial",
        "genre": "Werbung",
        "length": "1 Min",
        "year": "2019",
        "tasks": ["Editor", "Colorist"],
        "description": "Mit Beginn des Jahres 2012 hat die Landeshauptstadt Stuttgart die Umsetzung der Grundsicherung in alleiniger kommunaler Verantwortung übernommen. In Zusammenarbeit mit dem Jobcenter enstand ein Werbefilm mit Fokus auf Migration und Integration.",
        "festivals": "",

        "links": {
            "link": {
                "title":  "",
                "url":    "",
                "type":   ""
            }
        },
        "team": {
            "regie":        "Lorenz Piehl",
            "camera":       "Jonas Schneider",
            "editing":      "",
            "sounddesign":  "",
            "producer":     "Lorenz Piehl",
            "cast":         "Ramo Ali",
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "jobcenter-stuttgart-001.jpg"
                },
                {
                    "title": "",
                    "url":  "jobcenter-stuttgart-002.jpg"
                },
                {
                    "title": "",
                    "url":  "jobcenter-stuttgart-003.jpg"
                },
                {
                    "title": "",
                    "url":  "jobcenter-stuttgart-004.jpg"
                },
                {
                    "title": "",
                    "url":  "jobcenter-stuttgart-005.jpg"
                },
                {
                    "title": "",
                    "url":  "jobcenter-stuttgart-006.jpg"
                },
                {
                    "title": "",
                    "url":  "jobcenter-stuttgart-007.jpg"
                },
                {
                    "title": "",
                    "url":  "jobcenter-stuttgart-008.jpg"
                },
                {
                    "title": "",
                    "url":  "jobcenter-stuttgart-009.jpg"
                },
                {
                    "title": "",
                    "url":  "jobcenter-stuttgart-010.jpg"
                },
                {
                    "title": "",
                    "url":  "jobcenter-stuttgart-011.jpg"
                }
            ]
        }
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "50",
        "position": "",
        "name": "Because we dreamt of flying",
        "group": ["grading"],
        "filter": "fiction",
        "genre": "Fiction",
        "length": "90 Min",
        "year": "2019",
        "tasks": ["Colorist"],
        "description": "Marx, a suicidal German rich boy and Mercedes, a mysterious Russian woman, meet on the cliffs of beautiful South Italy. Soon, their dangerous attraction turns into a game with deadly consequences. ",
        "festivals": "",

        "team": {
            "regie":    "Lily Erlinger",
            "camera":   "",
            "editing":  "Tobias Wilhelmer",
            "producer": "Estella Suplit",
            "sounddesign": "Volker Armbruster",
            "cast":     "Lena Tronina, Louis von Klipstein, Federico Calisti, Carlotta Bazzu ",
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "because-we-dreamt-of-flying-001.jpg"
                },
                {
                    "title": "",
                    "url":  "because-we-dreamt-of-flying-002.jpg"
                },
                {
                    "title": "",
                    "url":  "because-we-dreamt-of-flying-003.jpg"
                },
                {
                    "title": "",
                    "url":  "because-we-dreamt-of-flying-004.jpg"
                },
                {
                    "title": "",
                    "url":  "because-we-dreamt-of-flying-005.jpg"
                },
                {
                    "title": "",
                    "url":  "because-we-dreamt-of-flying-006.jpg"
                },
                {
                    "title": "",
                    "url":  "because-we-dreamt-of-flying-007.jpg"
                },
                {
                    "title": "",
                    "url":  "because-we-dreamt-of-flying-008.jpg"
                },
                {
                    "title": "",
                    "url":  "because-we-dreamt-of-flying-009.jpg"
                },
                {
                    "title": "",
                    "url":  "because-we-dreamt-of-flying-010.jpg"
                },
                {
                    "title": "",
                    "url":  "because-we-dreamt-of-flying-011.jpg"
                },
                {
                    "title": "",
                    "url":  "because-we-dreamt-of-flying-012.jpg"
                },
                {
                    "title": "",
                    "url":  "because-we-dreamt-of-flying-013.jpg"
                },
                {
                    "title": "",
                    "url":  "because-we-dreamt-of-flying-014.jpg"
                },
                {
                    "title": "",
                    "url":  "because-we-dreamt-of-flying-015.jpg"
                },
                {
                    "title": "",
                    "url":  "because-we-dreamt-of-flying-016.jpg"
                },
                {
                    "title": "",
                    "url":  "because-we-dreamt-of-flying-017.jpg"
                },
                {
                    "title": "",
                    "url":  "because-we-dreamt-of-flying-018.jpg"
                },
                {
                    "title": "",
                    "url":  "because-we-dreamt-of-flying-019.jpg"
                }
            ]
        }
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "49",
        "position": "",
        "name": "Liridona",
        "group": ["grading"],
        "filter": "fiction",
        "genre": "Kurzfilm",
        "length": "8 MIN",
        "year": "2018",
        "tasks": ["Colorist"],
        "description": "",
        "festivals": "",

        "team": {
            "regie":    "Thilo Gundelach",
            "camera":   "Rafael Starman",
            "editing":  "Thilo Gundelach",
            "producer": "Lili Färberböck, Eduardo Roehrich",
            "cast":     "Albana Agaj, Anela Luzi, Veton Hamza",
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "liridona-001.jpg"
                },
                {
                    "title": "",
                    "url":  "liridona-002.jpg"
                },
                {
                    "title": "",
                    "url":  "liridona-003.jpg"
                },
                {
                    "title": "",
                    "url":  "liridona-004.jpg"
                },
                {
                    "title": "",
                    "url":  "liridona-005.jpg"
                },
                {
                    "title": "",
                    "url":  "liridona-006.jpg"
                },
                {
                    "title": "",
                    "url":  "liridona-007.jpg"
                },
                {
                    "title": "",
                    "url":  "liridona-008.jpg"
                },
                {
                    "title": "",
                    "url":  "liridona-009.jpg"
                },
                {
                    "title": "",
                    "url":  "liridona-010.jpg"
                }
            ]
        }
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "44",
        "position": "",
        "name": "Schloss Salem",
        "group": ["editing", "grading"],
        "filter": "commercial",
        "genre": "Werbung",
        "length": "1 Min",
        "year": "2018",
        "tasks": ["Editor", "Colorist"],
        "description": "In Zusammenarbeit mit der Schule Schloss Salem entstand dieser einminütige Teaser. Die Standorte der Schule, Schloss Salem, Schloss Spetzgart, der Campus Härlen und der Hafen in Überlingen dienten als Kulissen und die Darsteller fanden sich unter den Salemer Schülern, Lehrern und Mentoren.",
        "festivals": "",

        "team": {
            "regie":    "Lorenz Piehl",
            "camera":   "Maciej Rolbiecki",
            "editing":  "",
            "producer": "Jule Deumling",
            "cast":     "",
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "salem-001.jpg"
                },
                {
                    "title": "",
                    "url":  "salem-002.jpg"
                },
                {
                    "title": "",
                    "url":  "salem-003.jpg"
                },
                {
                    "title": "",
                    "url":  "salem-004.jpg"
                },
                {
                    "title": "",
                    "url":  "salem-005.jpg"
                },
                {
                    "title": "",
                    "url":  "salem-006.jpg"
                },
                {
                    "title": "",
                    "url":  "salem-007.jpg"
                },
                {
                    "title": "",
                    "url":  "salem-008.jpg"
                },
                {
                    "title": "",
                    "url":  "salem-009.jpg"
                },
                {
                    "title": "",
                    "url":  "salem-010.jpg"
                },
                {
                    "title": "",
                    "url":  "salem-011.jpg"
                },
                {
                    "title": "",
                    "url":  "salem-012.jpg"
                },
                {
                    "title": "",
                    "url":  "salem-013.jpg"
                }
            ]
        }
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "47",
        "position": "",
        "name": "Ratatoskr",
        "group": ["grading"],
        "filter": "animation",
        "genre": "Animation",
        "length": "3 Min",
        "year": "2018",
        "tasks": ["Colorist"],
        "description": "",
        "festivals": "",

        "team": {
            "regie":    "Meike Müller",
            "camera":   "",
            "editing":  "",
            "sounddesign": "Volker Armbruster",
            "producer": "Lena Lohfink",
            "cast":     "",
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "ratatoskr-001.jpg"
                },
                {
                    "title": "",
                    "url":  "ratatoskr-002.jpg"
                },
                {
                    "title": "",
                    "url":  "ratatoskr-003.jpg"
                },
                {
                    "title": "",
                    "url":  "ratatoskr-004.jpg"
                },
                {
                    "title": "",
                    "url":  "ratatoskr-005.jpg"
                },
                {
                    "title": "",
                    "url":  "ratatoskr-006.jpg"
                },
                {
                    "title": "",
                    "url":  "ratatoskr-007.jpg"
                },
                {
                    "title": "",
                    "url":  "ratatoskr-008.jpg"
                },
            ]
        }
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //


    {
        "id": "45",
        "position": "",
        "name": "Hella - Sexy Moves, sexy Products",
        "group": ["grading"],
        "filter": "commercial",
        "genre": "Werbung",
        "length": "1:30 Min",
        "year": "2018",
        "tasks": ["Colorist"],
        "description": "",
        "festivals": "",

        "links": {
            "link": {
                "title":  "Werbung ansehen",
                "url":    "https://vimeo.com/290447000",
                "type":   "video"
            }
        },
        "team": {
            "regie":    "Tarek Roehlinger & Lili Zahavi",
            "camera":   "Fabian Gamper",
            "editing":  "Bela Adami",
            "producer": "TriebKraft Films",
            "cast":     "Alexander Pollner, Christian A. Koch",
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "hella-sexy-moves-001.jpg"
                },
                {
                    "title": "",
                    "url":  "hella-sexy-moves-002.jpg"
                },
                {
                    "title": "",
                    "url":  "hella-sexy-moves-003.jpg"
                },
                {
                    "title": "",
                    "url":  "hella-sexy-moves-004.jpg"
                },
                {
                    "title": "",
                    "url":  "hella-sexy-moves-005.jpg"
                },
                {
                    "title": "",
                    "url":  "hella-sexy-moves-006.jpg"
                },
                {
                    "title": "",
                    "url":  "hella-sexy-moves-007.jpg"
                },
                {
                    "title": "",
                    "url":  "hella-sexy-moves-008.jpg"
                },
                {
                    "title": "",
                    "url":  "hella-sexy-moves-009.jpg"
                },
                {
                    "title": "",
                    "url":  "hella-sexy-moves-010.jpg"
                },
            ]
        }
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //


    {
        "id": "43",
        "position": "",
        "name": "Nach Gottes Maß",
        "group": ["editing"],
        "filter": "dok",
        "genre": "Dokumentarfilm",
        "length": "40 Min",
        "year": "2018",
        "tasks": ["Editor"],
        "description": "The film portrays a swabian family building up a carpentary school in the middle of the rwandan woods. Soon the project goes completly into rwandan hands. Director Sister Marie-Louise is worried. And the swabians have to prepare their farewell with heavy hearts. ",
        "festivals": "",

        "team": {
            "regie":    "Benjamin Rost & Oliver Völkel",
            "camera":   "Oliver Völkel",
            "editing":  "",
            "producer": "Marc Szilagyi",
            "cast":     "",
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "rtss-002.jpg"
                },
                {
                    "title": "",
                    "url":  "rtss-001.jpg"
                },
                {
                    "title": "",
                    "url":  "rtss-003.jpg"
                },
                {
                    "title": "",
                    "url":  "rtss-004.jpg"
                },
                {
                    "title": "",
                    "url":  "rtss-005.jpg"
                },
                {
                    "title": "",
                    "url":  "rtss-006.jpg"
                },
                {
                    "title": "",
                    "url":  "rtss-007.jpg"
                },
                {
                    "title": "",
                    "url":  "rtss-008.jpg"
                },
                {
                    "title": "",
                    "url":  "rtss-009.jpg"
                },
                {
                    "title": "",
                    "url":  "rtss-010.jpg"
                },
                {
                    "title": "",
                    "url":  "rtss-011.jpg"
                },
                {
                    "title": "",
                    "url":  "rtss-012.jpg"
                },
                {
                    "title": "",
                    "url":  "rtss-013.jpg"
                },
                {
                    "title": "",
                    "url":  "rtss-014.jpg"
                },
            ]
        }
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "76",
        "position": "",
        "name": "Beuys",
        "group": ["editing"],
        "filter": "dok",
        "genre": "Dokumentation",
        "length": "107 Min",
        "year": "2018",
        "tasks": ["Online Editor"],
        "description": "Beuys. Der Mann mit dem Hut, dem Filz und der Fettecke. 30 Jahre nach seinem Tod erscheint er uns als Visionär, der seiner Zeit voraus war." +
            "Aus einer kongenial montierten Collage unzähliger, bisher unerschlossener Bild- und Tondokumente stellen Regisseur Andres Veiel und sein Team ein einzigartiges Zeitdokument zusammen: „Beuys“ ist kein klassisches Porträt, sondern eine intime Betrachtung des Menschen, seiner Kunst und seiner Ideenräume.",
        "festivals": "Lola@Berlinale, 3 Nominierungen für den Deutschen Filmpreis, Lola für Bester Dokumentarfilm und Bester Schnitt, Deutscher Dokumentarfilm-Musikpreis ",
        "press": [
            {
                "title": "",
                "url":  "",
            }
        ],
        "links": [
            {
                "title":  "Trailer",
                "url":    "https://www.youtube.com/watch?v=NNqvx3PYu2E&feature=emb_title",
                "type":   ""
            }
        ],
        "team": {
            "regie":    "Andres Veiel",
            "camera": "Jörg Jeshel",
            "editing": "Stephan Krumbiegel & Olaf Voigtländer",
            "producer": "Zero One Film",
            "cast": "",
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "beuys-001.jpg"
                },
                {
                    "title": "",
                    "url":  "beuys-002.jpg"
                },
                {
                    "title": "",
                    "url":  "beuys-003.jpg"
                },
                {
                    "title": "",
                    "url":  "beuys-004.jpg"
                },

            ]
        },
        "videos": {
            "video": [
                {
                    "title": "",
                    "url":  ""
                }
            ]
        }
    },

    {
        "id": "42",
        "position": "",
        "name": "Plusmacher - Bar bezahlt",
        "group": ["grading"],
        "filter": "musikvideo",
        "genre": "Musikvideo",
        "length": "4 Min",
        "year": "2018",
        "tasks": ["Colorist"],
        "description": "",
        "festivals": "",

        "links": {
            "link": {
                "title":  "Musikvideo ansehen",
                "url":    "https://www.youtube.com/watch?v=RR5xAwcaCPs",
                "type":   "video"
            }
        },

        "team": {
            "regie":    "The BREED & Conrad Lobst",
            "camera":   "Bernhard Russow",
            "editing":  "Karl-Ludwig Lies",
            "producer": "The BREED & Conrad Lobst",
            "cast":     "",
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "plusmacher-001.jpg"
                },
                {
                    "title": "",
                    "url":  "plusmacher-002.jpg"
                },
                {
                    "title": "",
                    "url":  "plusmacher-003.jpg"
                },
                {
                    "title": "",
                    "url":  "plusmacher-004.jpg"
                },
                {
                    "title": "",
                    "url":  "plusmacher-005.jpg"
                },
                {
                    "title": "",
                    "url":  "plusmacher-006.jpg"
                },
                {
                    "title": "",
                    "url":  "plusmacher-007.jpg"
                },
                {
                    "title": "",
                    "url":  "plusmacher-008.jpg"
                },

            ]
        }
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "41",
        "position": "",
        "name": "Lonesome Rider (Volkswagen)",
        "group": ["grading"],
        "filter": "commercial",
        "genre": "Werbung",
        "length": "1 Min",
        "year": "2018",
        "tasks": ["Colorist"],
        "description": "",
        "festivals": "",

        "team": {
            "regie":    "Peer Andre Grote",
            "camera":   "Tim Weskamp",
            "editing":  "Kira König",
            "producer": "",
            "cast":     "",
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "lonesome-rider-001.jpg"
                },
                {
                    "title": "",
                    "url":  "lonesome-rider-002.jpg"
                },
                {
                    "title": "",
                    "url":  "lonesome-rider-003.jpg"
                },
                {
                    "title": "",
                    "url":  "lonesome-rider-004.jpg"
                },
                {
                    "title": "",
                    "url":  "lonesome-rider-005.jpg"
                },
                {
                    "title": "",
                    "url":  "lonesome-rider-006.jpg"
                },
                {
                    "title": "",
                    "url":  "lonesome-rider-007.jpg"
                },
            ]
        }
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "40",
        "position": "",
        "name": "Eterna - Always by your side",
        "group": ["grading"],
        "filter": "commercial",
        "genre": "Werbung",
        "length": "1 Min",
        "year": "2018",
        "tasks": ["Colorist"],
        "description": "Life is how you wear it. #eternabyyourside",
        "festivals": "",

        "links": {
            "link": {
                "title":  "Werbung ansehen",
                "url":    "https://www.youtube.com/watch?v=is7SyU1LFPQ",
                "type":   "video"
            }
        },

        "team": {
            "regie":    "Lara Witossek",
            "camera":   "Fabian Gamper",
            "editing":  "",
            "producer": "TriebKraft Film",
            "cast":     "",
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "eterna-001.jpg"
                },
                {
                    "title": "",
                    "url":  "eterna-002.jpg"
                },
                {
                    "title": "",
                    "url":  "eterna-003.jpg"
                },
                {
                    "title": "",
                    "url":  "eterna-004.jpg"
                },
                {
                    "title": "",
                    "url":  "eterna-005.jpg"
                },
                {
                    "title": "",
                    "url":  "eterna-006.jpg"
                },
                {
                    "title": "",
                    "url":  "eterna-007.jpg"
                },
                {
                    "title": "",
                    "url":  "eterna-008.jpg"
                },
                {
                    "title": "",
                    "url":  "eterna-009.jpg"
                }
            ]
        }
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "56",
        "position": "",
        "name": "Paris you got me",
        "group": ["grading"],
        "filter": "fiction",
        "genre": "Kurzfilm",
        "length": "8 Min",
        "year": "2018",
        "tasks": ["Colorist"],
        "description": "Auf ihrem täglichen Weg nach Hause stößt Ksenia zufällig auf den Straßenmaler George." +
            "Sekunden später befinden sich die beiden in einem parallelen Kosmos." +
            "Die Schritte verwandeln sich in Tanzschritte, Bewegungen in Farbspritzer, die Choreographie in Kunst und der Kreation einer eigenen Realität.",
        "festivals": "Über 120 Festivals und 30 Awards. Vollständige Liste: https://parisyougotme.com/filmfestivals/",

        "links": {
            "link": {
                "title":  "",
                "url":    "",
                "type":   ""
            }
        },
        "team": {
            "regie":    "Julie Boehm",
            "camera":   "Dominik Moos",
            "editing":  "Tobias Wilhelmer",
            "producer": "",
            "cast":     "Ksenia Parkhatskaya & Liam Scullion",
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "paris-you-got-me-001.jpg"
                },
                {
                    "title": "",
                    "url":  "paris-you-got-me-002.jpg"
                },
                {
                    "title": "",
                    "url":  "paris-you-got-me-003.jpg"
                },
                {
                    "title": "",
                    "url":  "paris-you-got-me-004.jpg"
                },
                {
                    "title": "",
                    "url":  "paris-you-got-me-005.jpg"
                },
                {
                    "title": "",
                    "url":  "paris-you-got-me-006.jpg"
                },
                {
                    "title": "",
                    "url":  "paris-you-got-me-007.jpg"
                },
                {
                    "title": "",
                    "url":  "paris-you-got-me-008.jpg"
                },
                {
                    "title": "",
                    "url":  "paris-you-got-me-009.jpg"
                },
            ]
        }
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "39",
        "position": "",
        "name": "Zero One Infinity",
        "group": ["grading"],
        "filter": "commercial",
        "genre": "Corporate",
        "length": "6 Min",
        "year": "2018",
        "tasks": ["Colorist"],
        "description": "",
        "festivals": "",

        "team": {
            "regie":    "Juri Kirchknopf",
            "camera":   "Joscha Kirchknopf ",
            "editing":  "",
            "producer": "",
            "cast":     "",
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "zoi-001.jpg"
                },
                {
                    "title": "",
                    "url":  "zoi-002.jpg"
                },
                {
                    "title": "",
                    "url":  "zoi-003.jpg"
                },
                {
                    "title": "",
                    "url":  "zoi-004.jpg"
                },
                {
                    "title": "",
                    "url":  "zoi-005.jpg"
                },
                {
                    "title": "",
                    "url":  "zoi-006.jpg"
                },
                {
                    "title": "",
                    "url":  "zoi-007.jpg"
                },
                {
                    "title": "",
                    "url":  "zoi-008.jpg"
                },
                {
                    "title": "",
                    "url":  "zoi-009.jpg"
                }
            ]
        }
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "38",
        "position": "",
        "name": "Die Galerie der vergessenen Berufe",
        "group": ["grading"],
        "filter": "fiction",
        "genre": "Kurzfilm",
        "length": "3 Min",
        "year": "2018",
        "tasks": ["Colorist"],
        "description": "",
        "festivals": "",

        "team": {
            "regie":    "Willi Kubica",
            "camera":   "Tim Weskamp",
            "editing":  "Willi Kubica",
            "producer": "Julia Deumling",
            "cast":     "",
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "dgdvb-001.jpg"
                },
                {
                    "title": "",
                    "url":  "dgdvb-002.jpg"
                },
                {
                    "title": "",
                    "url":  "dgdvb-003.jpg"
                },
                {
                    "title": "",
                    "url":  "dgdvb-004.jpg"
                },
                {
                    "title": "",
                    "url":  "dgdvb-005.jpg"
                },
                {
                    "title": "",
                    "url":  "dgdvb-006.jpg"
                },
                {
                    "title": "",
                    "url":  "dgdvb-007.jpg"
                },
                {
                    "title": "",
                    "url":  "dgdvb-008.jpg"
                },
                {
                    "title": "",
                    "url":  "dgdvb-009.jpg"
                }
            ]
        }
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "37",
        "position": "",
        "name": "PeTA - Men of the Stoneage",
        "group": ["grading"],
        "filter": "commercial",
        "genre": "Werbung",
        "length": "1 Min",
        "year": "2018",
        "tasks": ["Colorist"],
        "description": "",
        "festivals": "",

        "links": {
            "link": {
                "title":  "Werbung ansehen",
                "url":    "https://vimeo.com/254678100",
                "type":   "video"
            }
        },
        "team": {
            "regie":    "Tarek Roehlinger",
            "camera":   "Rafael Starman",
            "editing":  "David Gesselbauer",
            "producer": "TriebKraft Film",
            "cast":     "",
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "peta-001.jpg"
                },
                {
                    "title": "",
                    "url":  "peta-002.jpg"
                },
                {
                    "title": "",
                    "url":  "peta-003.jpg"
                },
                {
                    "title": "",
                    "url":  "peta-004.jpg"
                },
                {
                    "title": "",
                    "url":  "peta-005.jpg"
                },
                {
                    "title": "",
                    "url":  "peta-006.jpg"
                },
                {
                    "title": "",
                    "url":  "peta-007.jpg"
                },
                {
                    "title": "",
                    "url":  "peta-008.jpg"
                },
                {
                    "title": "",
                    "url":  "peta-009.jpg"
                },
                {
                    "title": "",
                    "url":  "peta-010.jpg"
                }
            ]
        }
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "36",
        "position": "",
        "name": "Swift Current",
        "group": ["grading"],
        "filter": ["dok", "commercial"],
        "genre": "Social Spot",
        "length": "5:30 Min",
        "year": "2017",
        "tasks": ["Colorist"],
        "description": "Swift Current is an Amskapi Pikuni. A tribal member of the Blackfeet Nation in Northwest\n" +
            "Montana, USA. And a cowboy.\n" +
            "\n" +
            "Wild at heart he goes to Rodeos – riding Broncos. 8 seconds thrill ride like once his ancestors chasing buffalo. His pragmatism struck me. In the vastness of the Blackfeet country Swift Currents mindset seems like a rare yet strong blossom - trying to make the most of it. It is an example of a human being in the 21st century. It shows the pride of a young man in a world of contradictions. That how you look on life is a matter of perspective. And that you should feel proud being a Native American.",
        "festivals": "",

        "team": {
            "regie":    "Thilo Gundelach",
            "camera":   "Leonhard Kaufmann",
            "editing":  "Thilo Gundelach",
            "producer": "",
            "cast":     "",
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "swift-current-001.jpg"
                },
                {
                    "title": "",
                    "url":  "swift-current-002.jpg"
                },
                {
                    "title": "",
                    "url":  "swift-current-003.jpg"
                },
                {
                    "title": "",
                    "url":  "swift-current-004.jpg"
                },
                {
                    "title": "",
                    "url":  "swift-current-005.jpg"
                },
                {
                    "title": "",
                    "url":  "swift-current-006.jpg"
                },
                {
                    "title": "",
                    "url":  "swift-current-007.jpg"
                },
                {
                    "title": "",
                    "url":  "swift-current-008.jpg"
                },
                {
                    "title": "",
                    "url":  "swift-current-009.jpg"
                },
                {
                    "title": "",
                    "url":  "swift-current-010.jpg"
                },
                {
                    "title": "",
                    "url":  "swift-current-011.jpg"
                },
                {
                    "title": "",
                    "url":  "swift-current-012.jpg"
                },
                {
                    "title": "",
                    "url":  "swift-current-013.jpg"
                }
            ]
        }
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "35",
        "position": "",
        "name": "Fatal & Rico Feat. Kontra K",
        "group": ["grading"],
        "filter": "musikvideo",
        "genre": "Musikvideo",
        "length": "4:45 Min",
        "year": "2017",
        "tasks": ["Colorist"],
        "description": "",
        "festivals": "",

        "links": {
            "link": {
                "title":  "Musikvideo ansehen",
                "url":    "https://www.youtube.com/watch?v=QIAu8YQ83BE",
                "type":   "video"
            }
        },

        "team": {
            "regie":    "Gerrit Klein",
            "camera":   "Jonas Schneider",
            "editing":  "David Gesselbauer",
            "producer": "",
            "cast":     "",
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "kontra-k-001.jpg"
                },
                {
                    "title": "",
                    "url":  "kontra-k-002.jpg"
                },
                {
                    "title": "",
                    "url":  "kontra-k-003.jpg"
                },
                {
                    "title": "",
                    "url":  "kontra-k-004.jpg"
                },
                {
                    "title": "",
                    "url":  "kontra-k-005.jpg"
                },
                {
                    "title": "",
                    "url":  "kontra-k-006.jpg"
                },
                {
                    "title": "",
                    "url":  "kontra-k-007.jpg"
                },
                {
                    "title": "",
                    "url":  "kontra-k-008.jpg"
                },
                {
                    "title": "",
                    "url":  "kontra-k-009.jpg"
                },
                {
                    "title": "",
                    "url":  "kontra-k-010.jpg"
                },
                {
                    "title": "",
                    "url":  "kontra-k-011.jpg"
                },
                {
                    "title": "",
                    "url":  "kontra-k-012.jpg"
                }
            ]
        }
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "34",
        "position": "",
        "name": "Faces",
        "group": ["grading"],
        "filter": "commercial",
        "genre": "Fashion",
        "length": "1:30 Min",
        "year": "2018",
        "tasks": ["Colorist"],
        "description": "",
        "festivals": "",

        "team": {
            "regie":    "Jonas Schneider",
            "camera":   "Jonas Schneider",
            "editing":  "",
            "producer": "",
            "cast":     "",
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "faces-001.jpg"
                },
                {
                    "title": "",
                    "url":  "faces-002.jpg"
                },
                {
                    "title": "",
                    "url":  "faces-003.jpg"
                },
                {
                    "title": "",
                    "url":  "faces-004.jpg"
                },
                {
                    "title": "",
                    "url":  "faces-005.jpg"
                },
                {
                    "title": "",
                    "url":  "faces-006.jpg"
                },
                {
                    "title": "",
                    "url":  "faces-007.jpg"
                },
                {
                    "title": "",
                    "url":  "faces-008.jpg"
                }
            ]
        }
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "33",
        "position": "",
        "name": "Franz",
        "group": ["grading"],
        "filter": "fiction",
        "genre": "Kurfzilm",
        "length": "20 Min",
        "year": "2018",
        "tasks": ["Colorist"],
        "description": "",
        "festivals": "",

        "team": {
            "regie":    "Adrian Goiginger",
            "camera":   "Jonas Schneider",
            "editing":  "Tobias Wilhelmer",
            "producer": "Gerrit Klein",
            "cast":     "Vinzenz Wagner, Sylvester Groth",
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "franz-002.jpg"
                },
                {
                    "title": "",
                    "url":  "franz-001.jpg"
                },
                {
                    "title": "",
                    "url":  "franz-003.jpg"
                },
                {
                    "title": "",
                    "url":  "franz-004.jpg"
                },
                {
                    "title": "",
                    "url":  "franz-005.jpg"
                },
                {
                    "title": "",
                    "url":  "franz-006.jpg"
                },
                {
                    "title": "",
                    "url":  "franz-007.jpg"
                },
                {
                    "title": "",
                    "url":  "franz-008.jpg"
                }
            ]
        }
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "32",
        "position": "",
        "name": "Fuchsblut - Trailer",
        "group": ["grading"],
        "filter": "fiction",
        "genre": "Trailer",
        "length": "1:30 Min",
        "year": "2017",
        "tasks": ["Colorist"],
        "description": "",
        "festivals": "",

        "team": {
            "regie":    "Julia Deumling",
            "camera":   "",
            "editing":  "",
            "producer": "Julia Deumling",
            "cast":     "",
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "fuchsblut-001.jpg"
                },
                {
                    "title": "",
                    "url":  "fuchsblut-002.jpg"
                },
                {
                    "title": "",
                    "url":  "fuchsblut-003.jpg"
                },
                {
                    "title": "",
                    "url":  "fuchsblut-004.jpg"
                },
                {
                    "title": "",
                    "url":  "fuchsblut-005.jpg"
                },
                {
                    "title": "",
                    "url":  "fuchsblut-006.jpg"
                }
            ]
        }
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "30",
        "position": "",
        "name": "Walls",
        "group": ["grading"],
        "filter": ["fiction", "musikvideo"],
        "genre": "Kurzfilm",
        "length": "7 Min",
        "year": "2017",
        "tasks": ["Grading (@WeFadeToGrey)"],
        "description": "WALLS - a music video / short film dealing with the energy generated through human confrontations with walls.\\\\n    The urge for freedom and fulfillment is just as human as the urge to build walls for everyday order.\\\\n    Three individuals in different countries are struggling under this tension - and finally decide to go all in. The soundtrack features music by rising french producer Phazz.",
        "festivals": "    \"2017 Student Academy Awards® / SEMI FINALIST\",\n" +
            "            \"2017 European Cinematography Award / Best Music Video / WINNER\",\n" +
            "            \"2017 Sydney World Film Festival / Best Narrative Short / WINNER\",\n" +
            "            \"2017 Los Angeles Music Video Underground / Best Director / WINNER\",\n" +
            "            \"2017 Paris Music Video Underground / Best Music Video / WINNER\",\n" +
            "            \"2017 Holly Shorts Film Festival / Academy Awards® Qualifying / OFFICIAL SELECTION\",\n" +
            "            \"2017 Berlin Short Film Festival / OFFICIAL SELECTION\",\n" +
            "            \"2017 LIFE AFTER OIL International Film Festival / OFFICIAL SELECTION\",\n" +
            "            \"2017 Berlin Student Film Festival / Music Video / OFFICIAL SELECTION\",\n" +
            "            \"2017 Sehsüchte Student Film Festival / Music Video / OFFICIAL SELECTION\",\n" +
            "            \"2017 20MINMAX International Shortfilm Festival / OFFICIAL SELECTION\",\n" +
            "            \"2017 NXD Free Film Festival / European Shorts / OFFICIAL SELECTION",

        "links": {
            "link": {
                "title":  "Kurzfilm ansehen",
                "url":    "https://vimeo.com/203803551",
                "type":   "video"
            }
        },

        "team": {
            "regie":    "Maik Schuster, Fatmir Dolci, Max Paschke",
            "camera":   "Maik Schuster",
            "editing":  "Max Paschke",
            "producer": "",
            "cast":     "",
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "walls-001.jpg"
                },
                {
                    "title": "",
                    "url":  "walls-002.jpg"
                },
                {
                    "title": "",
                    "url":  "walls-003.jpg"
                },
                {
                    "title": "",
                    "url":  "walls-004.jpg"
                },
                {
                    "title": "",
                    "url":  "walls-005.jpg"
                },
                {
                    "title": "",
                    "url":  "walls-006.jpg"
                },
                {
                    "title": "",
                    "url":  "walls-007.jpg"
                },
                {
                    "title": "",
                    "url":  "walls-008.jpg"
                },
                {
                    "title": "",
                    "url":  "walls-009.jpg"
                },
                {
                    "title": "",
                    "url":  "walls-010.jpg"
                },
                {
                    "title": "",
                    "url":  "walls-011.jpg"
                },
                {
                    "title": "",
                    "url":  "walls-012.jpg"
                },
                {
                    "title": "",
                    "url":  "walls-013.jpg"
                }
            ]
        }
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "29",
        "position": "",
        "name": "The Kelly Family - Nanana",
        "group": ["grading"],
        "filter": "musikvideo",
        "genre": "Musikvideo",
        "length": "4 Min",
        "year": "2017",
        "tasks": ["Grading (@WeFadeToGrey)"],
        "description": "",
        "festivals": "",

        "links": {
            "link": {
                "title":  "Musikvideo ansehen",
                "url":    "https://www.youtube.com/watch?v=btNGf_pCeZw",
                "type":   "video"
            }
        },

        "team": {
            "regie":    "Stefan Siebert",
            "camera":   "",
            "editing":  "",
            "producer": "",
            "cast":     "",
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "kelly-family-001.jpg"
                },
                {
                    "title": "",
                    "url":  "kelly-family-002.jpg"
                },
                {
                    "title": "",
                    "url":  "kelly-family-003.jpg"
                },
                {
                    "title": "",
                    "url":  "kelly-family-004.jpg"
                },
                {
                    "title": "",
                    "url":  "kelly-family-005.jpg"
                },
                {
                    "title": "",
                    "url":  "kelly-family-006.jpg"
                },
                {
                    "title": "",
                    "url":  "kelly-family-007.jpg"
                },
                {
                    "title": "",
                    "url":  "kelly-family-008.jpg"
                }
            ]
        },
        "videos": {
            "video": [
                {
                    "title": "",
                    "url":  ""
                }
            ]
        }
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "28",
        "position": "",
        "name": "Masala Chai",
        "group": ["grading"],
        "filter": "dok",
        "genre": "Dokumentarfilm",
        "length": "70 Min",
        "year": "2017",
        "tasks": ["Grading (@WeFadeToGrey)"],
        "description": "Der Film \"Masala Chai\" gibt einen tiefen Einblick in das Leben von fünf Teeköchen, deren Alltag sich sehr voneinander unterscheidet. Es ist ein emotionaler und informativer Dokumentarfilm über die gesellschaftlichen Umstände, Kontraste und Traditionen Indiens. Der Film erhielt eine Förderung von Hessenfilm.",
        "festivals": "",

        "links": {
            "link": {
                "title":  "Trailer ansehen",
                "url":    "https://www.youtube.com/watch?v=hGHD3pqkKmk",
                "type":   "video"
            }
        },

        "team": {
            "regie":    "Marco Hülser",
            "camera":   "Shamin Kulkarni",
            "editing":  "Marco Hülser",
            "producer": "Enkelejd Lluca, Ketaki Narayan",
            "cast":     "",
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "masala-chai-001.jpg"
                },
                {
                    "title": "",
                    "url":  "masala-chai-002.jpg"
                },
                {
                    "title": "",
                    "url":  "masala-chai-003.jpg"
                },
                {
                    "title": "",
                    "url":  "masala-chai-004.jpg"
                },
                {
                    "title": "",
                    "url":  "masala-chai-005.jpg"
                },
                {
                    "title": "",
                    "url":  "masala-chai-006.jpg"
                },
                {
                    "title": "",
                    "url":  "masala-chai-007.jpg"
                },
                {
                    "title": "",
                    "url":  "masala-chai-008.jpg"
                },
                {
                    "title": "",
                    "url":  "masala-chai-009.jpg"
                },
                {
                    "title": "",
                    "url":  "masala-chai-010.jpg"
                },
                {
                    "title": "",
                    "url":  "masala-chai-011.jpg"
                }
            ]
        }
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "27",
        "position": "",
        "name": "Zorn dem Volke",
        "group": ["grading", "editing"],
        "filter": "fiction",
        "genre": "Oneshot Kurzfilm",
        "length": "12 Min",
        "year": "2017",
        "tasks": ["Editor", "Colorist"],
        "description": "\"Tagebuch, Nikolai Berlin 15.Mai 2040:\",\n" +
            "\"Wir sind jung, wir sind studiert, sind resigniert. Mit Politik wollen wir nichts zu tun haben, aber alles wollen wir verändern.\\n    Die Werkzeuge der Demokratie wollen wir dazu nicht nutzen. Unsere Meinungen werden immer extremer, unser Umfeld radikaler. Doch gleichermaßen sind wir alle passiver denn je. Das muss ich korrigieren. ZORN dem Volke.\"",
        "festivals": "25th Camerimage Official Selection, Special Jury Mention 25th Jaipur International Short Film Festival, Official Selection 29th Ankara International Film Festival, Official Selection 47th Sehsüchte, Official Selection Manifesto Radical Film Festival Amsterdam, Official Selection 9th Jagran Film Festival, Official Selection Ariano International Film Festival, Official Selection Dea Film Fest, Best Short 7th Festival de Cine Sabado, Official Selection 20th Religion Today Film Festival Trento, Fantasy Film Fest, Official Selection 33th Unabhängiges FilmFest Osnabrück, Official Selection FILMZ, Official Selection 14th Early Bird International Student Film Festival, Official Selection 39th Festival du Film Court De Villeurbanne Official Selection 24th Filmschau Baden-Württemberg, Nominated Best Setdesign Watersprite Film Festival",

        "team": {
            "regie":    "Lorenz Piehl",
            "camera":   "Jonas Schneider",
            "editing":  "",
            "producer": "Max Becht",
            "cast":     "Eric Bouwer, Roeland Fernhout, Thorsten Krohn",
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "zorn-dem-volke-001.jpg"
                },
                {
                    "title": "",
                    "url":  "zorn-dem-volke-002.jpg"
                },
                {
                    "title": "",
                    "url":  "zorn-dem-volke-003.jpg"
                },
                {
                    "title": "",
                    "url":  "zorn-dem-volke-004.jpg"
                },
                {
                    "title": "",
                    "url":  "zorn-dem-volke-005.jpg"
                },
                {
                    "title": "",
                    "url":  "zorn-dem-volke-006.jpg"
                },
                {
                    "title": "",
                    "url":  "zorn-dem-volke-007.jpg"
                },
                {
                    "title": "",
                    "url":  "zorn-dem-volke-008.jpg"
                },
                {
                    "title": "",
                    "url":  "zorn-dem-volke-009.jpg"
                },
                {
                    "title": "",
                    "url":  "zorn-dem-volke-010.jpg"
                }
            ]
        },
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "26",
        "position": "",
        "name": "Bed",
        "group": ["editing", "grading"],
        "filter": "commercial",
        "genre": "Werbung",
        "length": "1:30 Min",
        "year": "2017",
        "tasks": ["Editor", "Colorist"],
        "description": "Ein Spec Spot für Ikea. Ein Mann öffnet seine Augen. Er liegt in einem Bett. Um ihn nichts als Wüste, brennende Betten und dunkler Rauch." +
            "Er fliegt mit seinem Bett bis nur noch Trümmer davon übrig sind. Auf der Suche nach dem Neuen um die alte Welt hinter sich lassen zu können.",
        "festivals": "",

        "team": {
            "regie":    "",
            "camera":   "Jonas Schneider",
            "editing":  "",
            "producer": "Sebastian Johannsen",
            "cast":     "Leandro Taub",
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "bed-001.jpg"
                },
                {
                    "title": "",
                    "url":  "bed-002.jpg"
                },
                {
                    "title": "",
                    "url":  "bed-003.jpg"
                },
                {
                    "title": "",
                    "url":  "bed-004.jpg"
                },
                {
                    "title": "",
                    "url":  "bed-005.jpg"
                },
                {
                    "title": "",
                    "url":  "bed-006.jpg"
                },
            ]
        }
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "31",
        "position": "",
        "name": "Der Treue größter Akt",
        "group": ["grading"],
        "filter": "fiction",
        "genre": "Kurzfilm",
        "length": "23 Min",
        "year": "2017",
        "tasks": ["Colorist"],
        "description": "Der Film erzählt von Hagen von Tronje als langjährigem Sicherheitsbeauftragten des Waffenkonglomerats Burgund-Holding, der sich einen blutigen Machtkampf mit Kriemhild und Siegfried um die Firma liefert. Action-Thriller basierend auf dem Nibelungenlied.",
        "festivals": "",

        "team": {
            "regie":    "Adrian Goiginger",
            "camera":   "Jonas Schneider",
            "editing":  "David Gesselbauer",
            "producer": "",
            "cast":     "Michael-Joachim Heiss, David Schütter, Verena Altenberger",
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "dtga-001.jpg"
                },
                {
                    "title": "",
                    "url":  "dtga-002.jpg"
                },
                {
                    "title": "",
                    "url":  "dtga-003.jpg"
                },
                {
                    "title": "",
                    "url":  "dtga-004.jpg"
                },
                {
                    "title": "",
                    "url":  "dtga-005.jpg"
                },
                {
                    "title": "",
                    "url":  "dtga-006.jpg"
                },
                {
                    "title": "",
                    "url":  "dtga-007.jpg"
                },
                {
                    "title": "",
                    "url":  "dtga-008.jpg"
                },
                {
                    "title": "",
                    "url":  "dtga-009.jpg"
                },
                {
                    "title": "",
                    "url":  "dtga-010.jpg"
                },
                {
                    "title": "",
                    "url":  "dtga-011.jpg"
                },
                {
                    "title": "",
                    "url":  "dtga-012.jpg"
                }
            ]
        },
        "videos": {
            "video": [
                {
                    "title": "",
                    "url":  ""
                }
            ]
        }
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "555",
        "position": "",
        "name": "Color Showreel 2016",
        "group": ["grading", "showreel"],
        "filter": "showreel",
        "genre": "Showreel",
        "length": "2 Min",
        "year": "2016",
        "tasks": "",
        "description": "Ein Colorgrading Showreel aus dem Jahr 2016. Projekte hauptsächlich aus dem Zeitraum 2014-2016.",
        "festivals": "",

        "videos": {
            "video": [
                {
                    "title": "",
                    "url":  "grading-showreel-2016.mov"
                }
            ]
        }
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "25",
        "position": "",
        "name": "Skywriters",
        "group": ["grading"],
        "filter": "dok",
        "genre": "Dokumentarfilm",
        "length": "17 Min",
        "year": "2016",
        "tasks": ["Colorist"],
        "description": "Skywriters is an aviation documentary that depicts the American history of skywriting and its evolution into the latest invention called skytyping.\n\tThe Stinis, only one single family but now already three generations of skywriters have dedicated all the passion to make this special magic in the air happen day by day.",
        "festivals": "",

        "team": {
            "regie":    "Nils Otte",
            "camera":   "Conrad Lobst",
            "editing":  "",
            "producer": "Nils Otte",
            "cast":     "",
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "skywriters-001.jpg"
                },
                {
                    "title": "",
                    "url":  "skywriters-002.jpg"
                },
                {
                    "title": "",
                    "url":  "skywriters-003.jpg"
                },
                {
                    "title": "",
                    "url":  "skywriters-004.jpg"
                },
                {
                    "title": "",
                    "url":  "skywriters-005.jpg"
                },
                {
                    "title": "",
                    "url":  "skywriters-006.jpg"
                },
                {
                    "title": "",
                    "url":  "skywriters-007.jpg"
                },
                {
                    "title": "",
                    "url":  "skywriters-008.jpg"
                },
                {
                    "title": "",
                    "url":  "skywriters-009.jpg"
                },
                {
                    "title": "",
                    "url":  "skywriters-010.jpg"
                },
                {
                    "title": "",
                    "url":  "skywriters-011.jpg"
                },
                {
                    "title": "",
                    "url":  "skywriters-012.jpg"
                }
            ]
        }
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "48",
        "position": "",
        "name": "Planeta de Queso",
        "group": ["grading"],
        "filter": "animation",
        "genre": "Animation",
        "length": "1 Min",
        "year": "2015",
        "tasks": ["Colorist"],
        "description": "",
        "festivals": "",

        "team": {
            "regie":    "Matisse Gonzalez Jordan",
            "camera":   "",
            "editing":  "",
            "producer": "Matisse Gonzalez Jordan",
            "cast":     "",
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "pizza-party-001.jpg"
                },
                {
                    "title": "",
                    "url":  "pizza-party-002.jpg"
                },
                {
                    "title": "",
                    "url":  "pizza-party-003.jpg"
                },
                {
                    "title": "",
                    "url":  "pizza-party-004.jpg"
                },
                {
                    "title": "",
                    "url":  "pizza-party-005.jpg"
                },
                {
                    "title": "",
                    "url":  "pizza-party-006.jpg"
                },
                {
                    "title": "",
                    "url":  "pizza-party-007.jpg"
                },
                {
                    "title": "",
                    "url":  "pizza-party-008.jpg"
                }
            ]
        }
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "24",
        "position": "",
        "name": "Milliardenmarsch",
        "group": ["grading"],
        "filter": "fiction",
        "genre": "Kurzfilm",
        "length": "17 Min",
        "year": "2015",
        "tasks": ["Colorist"],
        "description": "20 Jugendliche marschieren gegeneinander um eine Milliarde Preisgeld.\n\tDie Regeln sind simpel: Wer stehen bleibt, stirbt, und nur der Letzte überlebt! Der Film wurde auf 16mm Material gedreht.",
        "festivals": "",

        "team": {
            "regie":    "Adrian Goiginger",
            "camera":   "Jonas Schneider",
            "editing":  "",
            "producer": "Joel Basman, Marcel Heuperman, Julius Nitschkoff",
            "cast":     "",
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "milliardenmarsch-001.jpg"
                },
                {
                    "title": "",
                    "url":  "milliardenmarsch-002.jpg"
                },
                {
                    "title": "",
                    "url":  "milliardenmarsch-003.jpg"
                },
                {
                    "title": "",
                    "url":  "milliardenmarsch-004.jpg"
                },
                {
                    "title": "",
                    "url":  "milliardenmarsch-005.jpg"
                },
                {
                    "title": "",
                    "url":  "milliardenmarsch-006.jpg"
                },
                {
                    "title": "",
                    "url":  "milliardenmarsch-007.jpg"
                },
                {
                    "title": "",
                    "url":  "milliardenmarsch-008.jpg"
                },
                {
                    "title": "",
                    "url":  "milliardenmarsch-009.jpg"
                }
            ]
        }
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "54",
        "position": "",
        "name": "Erstaufnahme II",
        "group": ["editing"],
        "filter": "dok",
        "genre": "Dokumentarfilm",
        "length": "76 Min",
        "year": "2016",
        "tasks": ["Editor"],
        "description": "Ganz oben auf der Schwäbischen Alb eröffnet Ende 2014 die zweite Landeserstaufnahmestelle für Flüchtlinge in Baden-Württemberg.\n" +
            "\tWährend ihre Mitarbeiter die Arbeit aufnehmen, werden die neuen Bewohner zum Hauptgesprächsthema der Kleinstadt,\n" +
            "\tdie vor ihrer womöglich größten Herausforderung steht.",
        "festivals": "SWR Junger Dokumentarfilm, Official Selection Filmz Mainz 2016, Official Selection Human Rights Film Festival Berlin",

        "links": {
            "link": {
                "title":  "Trailer ansehen",
                "url":    "https://www.youtube.com/watch?v=RHA-o0P2KCw",
                "type":   "video"
            }
        },

        "team": {
            "regie":    "Pablo Ben-Yakov, Marc Eberhardt",
            "camera":   "Pablo Ben-Yakov, u.A.",
            "editing":  "",
            "producer": "Theres Bacza",
            "cast":     "Alfred Sauter, Karlo Gerstenecker, Ralf Greiner, Rebekka Lachmann",
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "erstaufnahme-2-001.jpg"
                },
                {
                    "title": "",
                    "url":  "erstaufnahme-2-002.jpg"
                },
                {
                    "title": "",
                    "url":  "erstaufnahme-2-003.jpg"
                },
                {
                    "title": "",
                    "url":  "erstaufnahme-2-004.jpg"
                },
                {
                    "title": "",
                    "url":  "erstaufnahme-2-005.jpg"
                },
                {
                    "title": "",
                    "url":  "erstaufnahme-2-006.jpg"
                },
                {
                    "title": "",
                    "url":  "erstaufnahme-2-007.jpg"
                },
                {
                    "title": "",
                    "url":  "erstaufnahme-2-008.jpg"
                },
                {
                    "title": "",
                    "url":  "erstaufnahme-2-009.jpg"
                },
                {
                    "title": "",
                    "url":  "erstaufnahme-2-010.jpg"
                },
                {
                    "title": "",
                    "url":  "erstaufnahme-2-011.jpg"
                }

            ]
        }
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "23",
        "position": "",
        "name": "Spätlese",
        "group": ["editing"],
        "filter": "fiction",
        "genre": "Kurzfilm",
        "length": "20 Min",
        "year": "2015",
        "tasks": ["16mm Linear Editing"],
        "description": "Der junge Schauspieler Michael stellt sich der deutlich älteren, mysteriösen Helene einen ganzen Tag lang zur Verfügung - „all inclusive“.\n\tEin aberwitziges Verwirrspiel aus Geld, Sex und doppelten Rollenspiel nimmt seinen Lauf. Als Teil des 16mm Semesters an der Filmakademie Baden-Württemberg wurde dieser Film auf 16mm Material gedreht und am Steenbeck geschnitten.",
        "festivals": "Filmzeit Kaufbeuren, Kurzsuechtig",

        "team": {
            "regie":    "Willi Kubica",
            "camera":   "Rafael Starman",
            "editing":  "",
            "producer": "Theresa Bacza, Stefanie Goedicke",
            "cast":     "Steve Schmidt, Gabrielle Scharnitzky",
        },


        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "spaetlese-012.jpg"
                },
                {
                    "title": "",
                    "url":  "spaetlese-001.jpg"
                },
                {
                    "title": "",
                    "url":  "spaetlese-002.jpg"
                },
                {
                    "title": "",
                    "url":  "spaetlese-003.jpg"
                },
                {
                    "title": "",
                    "url":  "spaetlese-004.jpg"
                },
                {
                    "title": "",
                    "url":  "spaetlese-005.jpg"
                },
                {
                    "title": "",
                    "url":  "spaetlese-013.jpg"
                },
                {
                    "title": "",
                    "url":  "spaetlese-014.jpg"
                },
                {
                    "title": "",
                    "url":  "spaetlese-006.jpg"
                },
                {
                    "title": "",
                    "url":  "spaetlese-007.jpg"
                },
                {
                    "title": "",
                    "url":  "spaetlese-008.jpg"
                },
                {
                    "title": "",
                    "url":  "spaetlese-009.jpg"
                },
                {
                    "title": "",
                    "url":  "spaetlese-010.jpg"
                },
                {
                    "title": "",
                    "url":  "spaetlese-011.jpg"
                },
                {
                    "title": "",
                    "url":  "spaetlese-015.jpg"
                }

            ]
        }
    },


    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "22",
        "position": "fiction",
        "name": "Jagon",
        "group": ["grading"],
        "filter": [""],
        "genre": "Kurzfilm",
        "length": "18 Min",
        "year": "2015",
        "tasks": ["Colorist"],
        "description": "Jagon, ein alter Jäger, zieht durch die nebligen Wälder auf der Suche nach Beute.\n\tEr findet eine mysteriöse Kette am Wegesrand. Plötzlich stehen maskierte Krieger vor ihm, die auf der Suche nach einer sarazenischen Prinzessin sind. Noch ahnt Jagon nicht, was für ein unerbittlicher Kampf ihm bevorsteht.",
        "festivals": "",

        "team": {
            "regie":    "Murat Gönültas",
            "camera":   "Tony Kopec",
            "editing":  "",
            "producer": "",
            "cast":     "Halit Dajdzo, Lin Gothoni, Mustafa Kuzu",
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "jagon-001.jpg"
                },
                {
                    "title": "",
                    "url":  "jagon-002.jpg"
                },
                {
                    "title": "",
                    "url":  "jagon-003.jpg"
                },
                {
                    "title": "",
                    "url":  "jagon-004.jpg"
                },
                {
                    "title": "",
                    "url":  "jagon-005.jpg"
                },
                {
                    "title": "",
                    "url":  "jagon-006.jpg"
                },
                {
                    "title": "",
                    "url":  "jagon-007.jpg"
                },
                {
                    "title": "",
                    "url":  "jagon-008.jpg"
                },
                {
                    "title": "",
                    "url":  "jagon-009.jpg"
                },
                {
                    "title": "",
                    "url":  "jagon-010.jpg"
                },
                {
                    "title": "",
                    "url":  "jagon-011.jpg"
                },
                {
                    "title": "",
                    "url":  "jagon-012.jpg"
                },
                {
                    "title": "",
                    "url":  "jagon-013.jpg"
                },
                {
                    "title": "",
                    "url":  "jagon-014.jpg"
                },
                {
                    "title": "",
                    "url":  "jagon-015.jpg"
                },
                {
                    "title": "",
                    "url":  "jagon-016.jpg"
                }
            ]
        }
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "21",
        "position": "",
        "name": "Herzlich Willkommen",
        "group": ["editing"],
        "filter": "dok",
        "genre": "Dokumentarfilm 16mm",
        "length": "34 Min",
        "year": "2015",
        "tasks": ["16mm Linear Editing"],
        "description": "Eine Kleinstadt auf der schwäbischen Alb. Eine verlassene Kaserne ist das vorübergehende Zuhause für etwa 1000 Flüchtlinge. Auch für Ahmad, Mohamad, Abraham und Yohannes. Sie haben ihr Leben riskiert, um anzukommen. Nun sind sie hier und warten auf die Zukunft. Als Teil des 16mm Semesters an der Filmakademie Baden-Württemberg wurde dieser Film auf 16mm Material gedreht und am Steenbeck geschnitten.",
        "festivals": "Official Selection STIFF Rijeka 2016, Inter. ShortFilm Festival Clermon-Ferrand, TrueDoc Documentary Festival",

        "team": {
            "regie":    "Pablo Ben-Yakov, Marc Eberhardt",
            "camera":   "Rafael Starman",
            "editing":  "Robin Jünkersfeld",
            "producer": "Theres Bacza",
            "cast":     "",
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "herzlich-willkommen-16mm-001.jpg"
                },
                {
                    "title": "",
                    "url":  "herzlich-willkommen-16mm-002.jpg"
                },
                {
                    "title": "",
                    "url":  "herzlich-willkommen-16mm-003.jpg"
                },
                {
                    "title": "",
                    "url":  "herzlich-willkommen-16mm-004.jpg"
                },
                {
                    "title": "",
                    "url":  "herzlich-willkommen-16mm-005.jpg"
                },
                {
                    "title": "",
                    "url":  "herzlich-willkommen-16mm-006.jpg"
                },
                {
                    "title": "",
                    "url":  "herzlich-willkommen-16mm-008.jpg"
                },
                {
                    "title": "",
                    "url":  "herzlich-willkommen-16mm-010.jpg"
                },
                {
                    "title": "",
                    "url":  "herzlich-willkommen-16mm-013.jpg"
                },
                {
                    "title": "",
                    "url":  "herzlich-willkommen-16mm-019.jpg"
                }
            ]
        }
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "20",
        "position": "",
        "name": "Ralli Babushka",
        "group": ["grading"],
        "filter": "commercial",
        "genre": "Werbung",
        "length": "1 Min",
        "year": "2015",
        "tasks": ["Colorist"],
        "description": "Irgendwo in den unendlichen Wäldern Russlands. Ein Rallyeauto knattert mit Vollgas über die als Rennstrecke ausgewiesene Matschpiste.\n\tAm Steuer eine rüstige Frau, Nadka, die hochkonzentriert die nächste Kurve nimmt. Daneben, als Co-Pilot, ihr in die Jahre gekommener Ehemann Fjodor.\n\tIm Fahrerlager erzählt der Rennrichter Lew, dass die beiden gerade wieder versuchen einen neuen Streckenrekord aufzustellen.\n\tFalls das tatsächlich gelingen sollte, sicherlich nur wegen Fjodor. Nadka ist ja nur eine Frau, eine alte Frau, so Lew.",
        "festivals": "",

        "team": {
            "regie":    "Thilo Gundelach",
            "camera":   "Rafael Starman",
            "editing":  "Moritz Poth",
            "producer": "",
            "cast":     "Adolfo Assor, Natalia Bobyleva, Victor Kraslavskiy",
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "ralli-babushka-001.jpg"
                },
                {
                    "title": "",
                    "url":  "ralli-babushka-002.jpg"
                },
                {
                    "title": "",
                    "url":  "ralli-babushka-003.jpg"
                },
                {
                    "title": "",
                    "url":  "ralli-babushka-004.jpg"
                },
                {
                    "title": "",
                    "url":  "ralli-babushka-005.jpg"
                },
                {
                    "title": "",
                    "url":  "ralli-babushka-006.jpg"
                },
                {
                    "title": "",
                    "url":  "ralli-babushka-007.jpg"
                },
                {
                    "title": "",
                    "url":  "ralli-babushka-008.jpg"
                }
            ]
        }
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "19",
        "position": "",
        "name": "Dead girls don't love",
        "group": ["grading"],
        "filter": "fiction",
        "genre": "Kurzfilm",
        "length": "9 Min",
        "year": "2015",
        "tasks": ["Colorist"],
        "description": "Vier Jugendliche brechen nachts in ein Schwimmbad ein, um zu feiern und zu trinken.\n\tDie Stimmung ist dabei trotzdem angespannt. Als dann noch eine Leiche unter der Dusche gefunden wird und klar ist,\n\tdass nicht mehr jedem in der Gruppe getraut werden kann, beginnt ein tödliches Spiel mit den Identitäten, das nicht alle überleben werden. Dabei ist kaum etwas wie es scheint und das Ende hält eine erstaunliche Überraschung bereit.",
        "festivals": "",

        "team": {
            "regie":    "Philipp Westerfeld",
            "camera":   "Marvin Schatz",
            "editing":  "",
            "producer": "",
            "cast":     "Michelle Barthel, Paula Kroh, Moritz Leu, Julius Nitschkoff"
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "dead-girls-dont-love-001.jpg"
                },
                {
                    "title": "",
                    "url":  "dead-girls-dont-love-002.jpg"
                },
                {
                    "title": "",
                    "url":  "dead-girls-dont-love-003.jpg"
                },
                {
                    "title": "",
                    "url":  "dead-girls-dont-love-004.jpg"
                },
                {
                    "title": "",
                    "url":  "dead-girls-dont-love-005.jpg"
                },
                {
                    "title": "",
                    "url":  "dead-girls-dont-love-006.jpg"
                },
                {
                    "title": "",
                    "url":  "dead-girls-dont-love-007.jpg"
                },
                {
                    "title": "",
                    "url":  "dead-girls-dont-love-008.jpg"
                },
                {
                    "title": "",
                    "url":  "dead-girls-dont-love-009.jpg"
                },
                {
                    "title": "",
                    "url":  "dead-girls-dont-love-010.jpg"
                }
            ]
        }
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "18",
        "position": "",
        "name": "Take the Chance",
        "group": ["grading"],
        "filter": "commercial",
        "genre": "Werbung",
        "length": "1 Min",
        "year": "2015",
        "tasks": ["Colorist"],
        "description": "",
        "festivals": "",

        "team": {
            "regie":    "Adrian Goiginger",
            "camera":   "",
            "editing":  "",
            "producer": "",
            "cast":     ""
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "take-the-chance-001.jpg"
                },
                {
                    "title": "",
                    "url":  "take-the-chance-002.jpg"
                },
                {
                    "title": "",
                    "url":  "take-the-chance-003.jpg"
                },
                {
                    "title": "",
                    "url":  "take-the-chance-004.jpg"
                },
                {
                    "title": "",
                    "url":  "take-the-chance-005.jpg"
                },
                {
                    "title": "",
                    "url":  "take-the-chance-006.jpg"
                },
                {
                    "title": "",
                    "url":  "take-the-chance-007.jpg"
                },
                {
                    "title": "",
                    "url":  "take-the-chance-008.jpg"
                },
            ]
        }
    },


    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "17",
        "position": "",
        "name": "Fukushima Water",
        "group": ["grading"],
        "filter": "commercial",
        "genre": "Werbung",
        "length": "4 Min",
        "year": "2015",
        "tasks": ["Colorist"],
        "description": "Vier Jahre nach der Kernschmelze im Kernkraftwerk Fukushima-Daichii erobert ein neuartiger Energy-Drink den japanischen Markt und avanciert innerhalb kürzester Zeit zum Kultgetränk in allen Altersklassen: Fukushima Water. Mit einer perfiden Marketingstrategie bewirbt sich der Drink als \"energy-water\" – ein natürliches Mineralwasser mit einem künstlichen Zusatzstoff. Nur ein schlechter Werbe-Gag eines japanischen Getränkeherstellers oder das absurdeste Produkt der Welt?",
        "festivals": "",

        "links": {
            "link": {
                "title":  "Werbung ansehen",
                "url":    "https://www.youtube.com/watch?v=hGHD3pqkKmk",
                "type":   "video"
            }
        },
        "team": {
            "regie":    "",
            "camera":   "Jonas Schneider",
            "editing":  "David Kuruc",
            "producer": "",
            "cast":     "Tomas Spencer, Yuki Iwamoto, Lieko Schulze"
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "fukushima-water-001.jpg"
                },
                {
                    "title": "",
                    "url":  "fukushima-water-002.jpg"
                },
                {
                    "title": "",
                    "url":  "fukushima-water-003.jpg"
                },
                {
                    "title": "",
                    "url":  "fukushima-water-004.jpg"
                },
                {
                    "title": "",
                    "url":  "fukushima-water-005.jpg"
                },
                {
                    "title": "",
                    "url":  "fukushima-water-006.jpg"
                },
                {
                    "title": "",
                    "url":  "fukushima-water-007.jpg"
                },
                {
                    "title": "",
                    "url":  "fukushima-water-008.jpg"
                }
            ]
        },
        "videos": {
            "video": [
                {
                    "title": "",
                    "url":  ""
                }
            ]
        }
    },


    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "16",
        "position": "",
        "name": "Ratten im Hamsterrad",
        "group": ["grading"],
        "filter": "fiction",
        "genre": "Kurzfilm",
        "length": "9 Min",
        "year": "2015",
        "tasks": ["Colorist"],
        "description": "Rupert wäre eigentlich ein Schauspieler geworden. Er wäre der Star der Bühne. Menschenmassen würden an seinen Lippen hängen. Doch auch wenn er die Stücke und deren Kunst, welche in seinem Theater aufgeführt werden, besser versteht als jeder andere, so wird er doch niemals ein Schauspieler sein. Er wird nicht gehört. Kein stiller Aufschrei wird dies ändern. Er wird immer der Rupert bleiben, der die Requisiten abstaubt und die Bühne immer nur dann betritt, wenn kein Publikum im Haus ist.",
        "festivals": "",

        "team": {
            "regie":    "Lorenz Piehl",
            "camera":   "Jonas Schneider",
            "editing":  "",
            "producer": "",
            "cast":     "Michael Gerlinger"
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "ratten-im-hamsterrad-006.jpg"
                },
                {
                    "title": "",
                    "url":  "ratten-im-hamsterrad-002.jpg"
                },
                {
                    "title": "",
                    "url":  "ratten-im-hamsterrad-003.jpg"
                },
                {
                    "title": "",
                    "url":  "ratten-im-hamsterrad-004.jpg"
                },
                {
                    "title": "",
                    "url":  "ratten-im-hamsterrad-005.jpg"
                },
                {
                    "title": "",
                    "url":  "ratten-im-hamsterrad-001.jpg"
                },
                {
                    "title": "",
                    "url":  "ratten-im-hamsterrad-007.jpg"
                },
                {
                    "title": "",
                    "url":  "ratten-im-hamsterrad-008.jpg"
                },
                {
                    "title": "",
                    "url":  "ratten-im-hamsterrad-009.jpg"
                },
                {
                    "title": "",
                    "url":  "ratten-im-hamsterrad-010.jpg"
                },
            ]
        }
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "15",
        "position": "",
        "name": "Homunculus",
        "group": ["grading"],
        "filter": "fiction",
        "genre": "Kurzfilm",
        "length": "8 Min",
        "year": "2015",
        "tasks": ["Colorist"],
        "description": "Ein experimenteller Kurzfilm über die Idee eines künstlich geschaffenen Menschen, der im Unterbewusstsein sitzt und sich deutlich bemerkbar macht. Das surreale Schauspiel eines Consulting Beraters in einem Hotelzimmer, der aufwacht und seine Sinne neu erfährt.",
        "festivals": "",

        "team": {
            "regie":    "Raphael Ghobadloo",
            "camera":   "Pierre Castillo Bernad",
            "editing":  "",
            "producer": "",
            "cast":     "Hadi Khanjanpour"
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "homunculus-001.jpg"
                },
                {
                    "title": "",
                    "url":  "homunculus-002.jpg"
                },
                {
                    "title": "",
                    "url":  "homunculus-003.jpg"
                },
                {
                    "title": "",
                    "url":  "homunculus-004.jpg"
                },
                {
                    "title": "",
                    "url":  "homunculus-005.jpg"
                },
                {
                    "title": "",
                    "url":  "homunculus-006.jpg"
                },
                {
                    "title": "",
                    "url":  "homunculus-007.jpg"
                },
                {
                    "title": "",
                    "url":  "homunculus-008.jpg"
                }
            ]
        }
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "14",
        "position": "",
        "name": "Perimeter",
        "group": ["editing"],
        "filter": "fiction",
        "genre": "Experimentalfilm",
        "length": "6 Min",
        "year": "2014",
        "tasks": ["Editor"],
        "description": "Ein Soldat auf der Flucht. In die Wälder, ins Nichts. Ein Strom aus Leben und Tod. Eine Suche nach dem, was passiert sein könnte. Ein Aufwachen aus dem Verschwommenen, dem Dickicht der Unwissenheit, der verzweifelten Hoffnung auf einen Albtraum. Perimeter ist in enger Zusammenarbeit mit Thilo Gundelach und Till Isken im Rahmen der Filmgestaltung 1 an der Filmakademie Baden-Württemberg entstanden. Mit einer offenen und variablen Rollenverteilung erlangten wir eine konstruktive Gleichberechtigung, mit vielen kreativen Gesprächen und Neufindungsprozessen.",
        "festivals": "",

        "team": {
            "regie":    "Thilo Gundelach, Till Isken, Robin Jünkersfeld",
            "camera":   "Thilo Gundelach, Till Isken, Robin Jünkersfeld",
            "editing":  "",
            "producer": "",
            "cast":     "Benjamin Jorns, Susanne Pfeiffer, Ingo Pfeiffer, Klaus Diedrich"
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "perimeter-001.jpg"
                },
                {
                    "title": "",
                    "url":  "perimeter-002.jpg"
                },
                {
                    "title": "",
                    "url":  "perimeter-003.jpg"
                },
                {
                    "title": "",
                    "url":  "perimeter-004.jpg"
                },
                {
                    "title": "",
                    "url":  "perimeter-005.jpg"
                },
                {
                    "title": "",
                    "url":  "perimeter-006.jpg"
                },
                {
                    "title": "",
                    "url":  "perimeter-007.jpg"
                },
                {
                    "title": "",
                    "url":  "perimeter-008.jpg"
                },
                {
                    "title": "",
                    "url":  "perimeter-009.jpg"
                },
                {
                    "title": "",
                    "url":  "perimeter-010.jpg"
                }
            ]
        },
        "videos": {
            "video": [
                {
                    "title": "",
                    "url":  ""
                }
            ]
        }
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "13",
        "position": "",
        "name": "Escaping Damascus",
        "group": ["grading"],
        "filter": "fiction",
        "genre": "Kurzfilm",
        "length": "13 Min",
        "year": "2014",
        "tasks": ["Colorist"],
        "description": "Seit einigen Jahren tobt in Syrien ein heftiger Bürgerkrieg der zum heutigen Zeitpunkt über 150.000 Tote forderte. Eine Gruppe von Flüchtlingen verlässt ihr Heimatland in einem Planwagen.\n\tUnter ihnen befinden sich zwei Brüder, Saaid und Wahid. Mit Hilfe von bewaffneten Unterstützern gelingt es den Flüchtenden zu entkommen. Unter Beschuss und im totalen Chaos beginnt die riskante Reise. Wie man in schwierigen und extremen Zeiten wie im Krieg mit dem Tod umgeht, zeigt sich in der Geschichte.",
        "festivals": "Hofer Filmtage",

        "links": {
            "link": {
                "title":  "Trailer ansehen",
                "url":    "https://vimeo.com/108484540",
                "type":   "video"
            }
        },
        "team": {
            "regie":    "Lorenz Piehl & Robin Weiland",
            "camera":   "Dominik Moos & Robin Jünkersfeld",
            "editing":  "Robin Weiland",
            "producer": "Sebastian Johannsen",
            "cast":     "Ramo Ali, Rezan Ferman, Yasemin Cetinkaya, Hassan Lazouane, Orhan Müstak, Heval Osman"
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "escaping-damascus-001.jpg"
                },
                {
                    "title": "",
                    "url":  "escaping-damascus-002.jpg"
                },
                {
                    "title": "",
                    "url":  "escaping-damascus-003.jpg"
                },
                {
                    "title": "",
                    "url":  "escaping-damascus-004.jpg"
                },
                {
                    "title": "",
                    "url":  "escaping-damascus-005.jpg"
                },
                {
                    "title": "",
                    "url":  "escaping-damascus-006.jpg"
                },
                {
                    "title": "",
                    "url":  "escaping-damascus-007.jpg"
                },
                {
                    "title": "",
                    "url":  "escaping-damascus-008.jpg"
                },
                {
                    "title": "",
                    "url":  "escaping-damascus-009.jpg"
                }
            ]
        }
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "12",
        "position": "",
        "name": "Stavanger Trailer",
        "group": ["editing"],
        "filter": "fiction",
        "genre": "Trailer",
        "length": "1 Min",
        "year": "2014",
        "tasks": ["Schnittassistenz", "Trailer Schnitt"],
        "description": "Marta ist Mitte 40 und träumt manchmal. Dann denkt sie noch an die schöne Zeit, die sie mit ihrem Mann Wolfgang erlebt hat, bevor sie den Bauernhof übernommen haben. Doch die tägliche harte Arbeit muss schließlich getan werden und es hilft nichts zu träumen. So leben die beiden aneinander vorbei und verdrängen die offensichtlichen Probleme ihrer Beziehung. Als Wolfgang aber eines Morgens nicht aus dem Stall zurückkehrt, bricht ihre wohlgeordnete Welt zusammen. Erst als die Vergangenheit mit Macht in ihr Leben drängt, beginnt sie, die Wahrheit an sich heranzulassen und zu tun, was getan werden muss.",
        "festivals": "",

        "links": {
            "link": {
                "title":  "Trailer ansehen",
                "url":    "https://vimeo.com/107282678",
                "type":   "video"
            }
        },
        "team": {
            "regie":    "Arto Sebastian",
            "camera":   "Simon Drescher",
            "editing":  "Jan Biehl",
            "producer": "Jasper Mielke & ",
            "cast":     "Ulrike Krumbiegel, Olaf Burmeister"
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "stavanger-001.jpg"
                },
                {
                    "title": "",
                    "url":  "stavanger-002.jpg"
                },
                {
                    "title": "",
                    "url":  "stavanger-003.jpg"
                },
                {
                    "title": "",
                    "url":  "stavanger-004.jpg"
                },
                {
                    "title": "",
                    "url":  "stavanger-005.jpg"
                },
                {
                    "title": "",
                    "url":  "stavanger-006.jpg"
                },
                {
                    "title": "",
                    "url":  "stavanger-007.jpg"
                },
                {
                    "title": "",
                    "url":  "stavanger-008.jpg"
                },
                {
                    "title": "",
                    "url":  "stavanger-009.jpg"
                },
                {
                    "title": "",
                    "url":  "stavanger-010.jpg"
                },
                {
                    "title": "",
                    "url":  "stavanger-011.jpg"
                },
                {
                    "title": "",
                    "url":  "stavanger-012.jpg"
                },
            ]
        }
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "11",
        "position": "",
        "name": "Klang der Stille",
        "group": ["grading"],
        "filter": "fiction",
        "genre": "Kurzfilm",
        "length": "13 Min",
        "year": "2014",
        "tasks": ["Colorist"],
        "description": "Die österreichischen Alpen, schneebedeckt und idyllisch. Der ideale Platz für den Kick einer Tiefschnee Backcountry Abfahrt. Doch die Idylle birgt Gefahren und einer der Extremsporter wird von einer selbstausgelösten Lawine verschüttet. Die einzige erreichbare Hilfe ist sein Partner. Es beginnt ein Kampf um Leben und Tod, doch die Überlebenszeit unter der massiven Schneemasse ist kurz.",
        "festivals": "8 Festival-Nominierungen, Erster Preis beim Internationalen Medienfestival in Villingen-Schwenningen",

        "team": {
            "regie":    "Adrian Goiginger",
            "camera":   "Paul Sprinz",
            "editing":  "Gürcan Cansever",
            "producer": "",
            "cast":     "Stefan Häusl, Björn Heregger"
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "klang-der-stille-001.jpg"
                },
                {
                    "title": "",
                    "url":  "klang-der-stille-002.jpg"
                },
                {
                    "title": "",
                    "url":  "klang-der-stille-003.jpg"
                },
                {
                    "title": "",
                    "url":  "klang-der-stille-004.jpg"
                },
                {
                    "title": "",
                    "url":  "klang-der-stille-005.jpg"
                },
                {
                    "title": "",
                    "url":  "klang-der-stille-006.jpg"
                },
            ]
        },
        "videos": {
            "video": [
                {
                    "title": "",
                    "url":  ""
                }
            ]
        }
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "10",
        "position": "",
        "name": "Rouge Et Noir Trailer",
        "group": ["editing"],
        "filter": "dok",
        "genre": "Dokumentarfilm Trailer",
        "length": "1 Min",
        "year": "2014",
        "tasks": ["Trailer Schnitt"],
        "description": "Erich Hasselberger ist 92 Jahre alt. Die meiste Zeit seines Tages schenkt er seiner Roulettforschung. Immer auf der Suche nach dem 'Verlauf der Kugel'.",
        "festivals": "",

        "links": {
            "link": {
                "title":  "Trailer ansehen",
                "url":    "https://vimeo.com/98723827",
                "type":   "video"
            }
        },
        "team": {
            "regie":    "Eva Gördes",
            "camera":   "Christine Lüdge",
            "editing":  "",
            "producer": "",
            "cast":     "Erich Hasselberger"
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "rouge-et-noir-001.jpg"
                },
                {
                    "title": "",
                    "url":  "rouge-et-noir-002.jpg"
                },
                {
                    "title": "",
                    "url":  "rouge-et-noir-003.jpg"
                },
                {
                    "title": "",
                    "url":  "rouge-et-noir-004.jpg"
                },
                {
                    "title": "",
                    "url":  "rouge-et-noir-005.jpg"
                },
                {
                    "title": "",
                    "url":  "rouge-et-noir-006.jpg"
                },
                {
                    "title": "",
                    "url":  "rouge-et-noir-007.jpg"
                },
                {
                    "title": "",
                    "url":  "rouge-et-noir-008.jpg"
                }
            ]
        },
        "videos": {
            "video": [
                {
                    "title": "",
                    "url":  ""
                }
            ]
        }
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    /*
   {
      "id": "9",
      "position": "",
      "name": "Wacom Roadshow",
      "group": ["editing"],
      "filter": "commercial",
      "genre": "Roadshow",
      "length": "1 Min",
      "year": "2014",
      "tasks": ["Editor"],
      "description": "Die Cintiq Companion Roadshow war im Januar und Februar 2014 auf Deutschland-Tour und machte Halt in Düsseldorf, Hamburg, Berlin, Frankfurt und München. Auf den Events hatten die Besucher die Möglichkeit Wacom Produkte zu testen. Neben der Möglichkeit sich bei Snacks und Getränken mit anderen Kreativen auszutauschen sorgten auch die Hands-on Sessions mit Automotive-Designer Michal Jelinek für Unterhaltung.",
      "festivals": "",

      "links": {
         "link": {
            "title":  "",
            "url":    "",
            "type":   ""
         }
      },
      "team": {
         "regie":    "",
         "camera":   "Maciej Rolbiecki",
         "editing":  "",
         "producer": "Yvonne Marburger",
         "cast":     ""
      },
      "images": {
         "image": [
            {
               "title": "",
               "url":  "wacom-roadshow-001.jpg"
            },
            {
               "title": "",
               "url":  "wacom-roadshow-002.jpg"
            },
            {
               "title": "",
               "url":  "wacom-roadshow-003.jpg"
            },
            {
               "title": "",
               "url":  "wacom-roadshow-004.jpg"
            },
            {
               "title": "",
               "url":  "wacom-roadshow-005.jpg"
            },
            {
               "title": "",
               "url":  "wacom-roadshow-006.jpg"
            },
            {
               "title": "",
               "url":  "wacom-roadshow-007.jpg"
            },
            {
               "title": "",
               "url":  "wacom-roadshow-008.jpg"
            },
            {
               "title": "",
               "url":  "wacom-roadshow-009.jpg"
            },
            {
               "title": "",
               "url":  "wacom-roadshow-010.jpg"
            },
            {
               "title": "",
               "url":  "wacom-roadshow-011.jpg"
            },
         ]
      }
   },

   */

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "8",
        "position": "",
        "name": "Rendezvous Trailer",
        "group": ["editing"],
        "filter": "fiction",
        "genre": "Trailer",
        "length": "1 Min",
        "year": "2013",
        "tasks": ["Trailer Schnitt"],
        "description": "Carla (mitte 20) stolpert Hals über Kopf in eine 'Amour Fou'. Als Jacob (Mitte 40) sie bittet nach Paris zu kommen, lässt sie alles stehen und liegen und trampt in die Stadt der Liebe. Doch leider entspricht weder Paris noch das Rendezvous ihrer romantischen Vorstellung.",
        "festivals": "",

        "links": {
            "link": {
                "title":  "Trailer ansehen",
                "url":    "https://vimeo.com/86461677",
                "type":   "video"
            }
        },
        "team": {
            "regie":    "Sylvia Borges",
            "camera":   "Claire Jahn",
            "editing":  "Moritz Poth",
            "producer": "",
            "cast":     "Daniela Schulz, Alexandar Jovanovic, Alex Martin"
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "rendezvous-001.jpg"
                },
                {
                    "title": "",
                    "url":  "rendezvous-002.jpg"
                },
                {
                    "title": "",
                    "url":  "rendezvous-003.jpg"
                },
                {
                    "title": "",
                    "url":  "rendezvous-004.jpg"
                },
                {
                    "title": "",
                    "url":  "rendezvous-005.jpg"
                },
                {
                    "title": "",
                    "url":  "rendezvous-006.jpg"
                }
            ]
        },
        "videos": {
            "video": [
                {
                    "title": "",
                    "url":  ""
                }
            ]
        }
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "7",
        "position": "",
        "name": "Das blühende Leben Trailer",
        "group": ["editing"],
        "filter": "fiction",
        "genre": "Trailer",
        "length": "1 Min",
        "year": "2013",
        "tasks": ["Trailer Schnitt"],
        "description": "Als der verwitwete Fockebernd im Wald einen Baum fällt, findet er in dem heimatlosen Efeuwesen Waldi einen Freund, der ihm über seine Einsamkeit hinweghilft. Doch schon bald muss Fockebernd feststellen, dass es keinen Sinn hat, sich an einen Moment zu klammern – wie der Efeu an seinen Baum.",
        "festivals": "",

        "links": {
            "link": {
                "title":  "Trailer ansehen",
                "url":    "https://vimeo.com/79397189",
                "type":   "video"
            }
        },
        "team": {
            "regie":    "Clemens Roth",
            "camera":   "Conrad Lobst",
            "editing":  "Julia Kovalenko",
            "producer": "",
            "cast":     "Thomas Balou Martin, Marco Albrecht"
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "das-bluehende-leben-001.jpg"
                },
                {
                    "title": "",
                    "url":  "das-bluehende-leben-002.jpg"
                },
                {
                    "title": "",
                    "url":  "das-bluehende-leben-003.jpg"
                },
                {
                    "title": "",
                    "url":  "das-bluehende-leben-004.jpg"
                },
                {
                    "title": "",
                    "url":  "das-bluehende-leben-005.jpg"
                },
                {
                    "title": "",
                    "url":  "das-bluehende-leben-006.jpg"
                },
                {
                    "title": "",
                    "url":  "das-bluehende-leben-007.jpg"
                },
                {
                    "title": "",
                    "url":  "das-bluehende-leben-008.jpg"
                },
                {
                    "title": "",
                    "url":  "das-bluehende-leben-009.jpg"
                },
            ]
        }
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "6",
        "position": "",
        "name": "Friedrich",
        "group": ["editing"],
        "filter": "fiction",
        "genre": "Kurzfilm",
        "length": "7 Min",
        "year": "2013",
        "tasks": ["Editor"],
        "description": "Friedrich hat im Krieg seine Familie und sein Zuhause verloren. Das einzige was übrig geblieben ist ist eine stehengebliebene Küchenuhr. Durch die Uhr erkennt er in der verlorenen alten Alltäglichkeit sein Paradies. Die Literaturadaption von Wolfgang Borchert ist ein Kurzfilmprojekt, das im Rahmen des Regie1 Quartals an der Filmakademie Baden-Württemberg entstanden ist. Der gesamte Prozess von Drehbuch bis zur finalen Fassung fand in Zusammenarbeit mit Dominik Moos statt.",
        "festivals": "",

        "team": {
            "regie":    "Dominik Moos, Robin Jünkersfeld",
            "camera":   "Moritz Poth, Benny Rost",
            "editing":  "",
            "producer": "",
            "cast":     "Matthias Bleier, Peter Kaghanovitch"
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "friedrich-005.jpg"
                },
                {
                    "title": "",
                    "url":  "friedrich-002.jpg"
                },
                {
                    "title": "",
                    "url":  "friedrich-004.jpg"
                },
                {
                    "title": "",
                    "url":  "friedrich-007.jpg"
                },
                {
                    "title": "",
                    "url":  "friedrich-006.jpg"
                },
                {
                    "title": "",
                    "url":  "friedrich-001.jpg"
                },
            ]
        }
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "5",
        "position": "",
        "name": "Vom Leben zu wenig, vom Sterben zu viel",
        "group": ["editing"],
        "filter": "fiction",
        "genre": "Kurzfilm",
        "length": "29 Min",
        "year": "2013",
        "tasks": ["Editor"],
        "description": "Der Film ist eine Adaption von Goethes 'Erlkönig'. Es geht um eine, zerbrochene Familie, die sich am Sterbebett des Großvaters zusammenfindet.\n\tParallel zum „Todeskampf“ des Großvaters in surrealen Begegnungen mit dem Erlkönig droht die gespannte Situation innerhalb der Familie zu eskalieren.",
        "festivals": "",

        "links": {
            "link": {
                "title":  "Trailer ansehen",
                "url":    "https://vimeo.com/63190208",
                "type":   "video"
            }
        },
        "team": {
            "regie":    "Jan Oberdick",
            "camera":   "Maciej Rolbiecki",
            "editing":  "",
            "producer": "",
            "cast":     "Stefan Franz, Victor Leohnhardt, Thomas Küsters, Carolin Stähler"
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "vom-leben-zu-wenig-001.jpg"
                },
                {
                    "title": "",
                    "url":  "vom-leben-zu-wenig-002.jpg"
                },
                {
                    "title": "",
                    "url":  "vom-leben-zu-wenig-003.jpg"
                },
                {
                    "title": "",
                    "url":  "vom-leben-zu-wenig-004.jpg"
                },
                {
                    "title": "",
                    "url":  "vom-leben-zu-wenig-005.jpg"
                },
                {
                    "title": "",
                    "url":  "vom-leben-zu-wenig-006.jpg"
                },
                {
                    "title": "",
                    "url":  "vom-leben-zu-wenig-007.jpg"
                },
                {
                    "title": "",
                    "url":  "vom-leben-zu-wenig-008.jpg"
                },
                {
                    "title": "",
                    "url":  "vom-leben-zu-wenig-009.jpg"
                },
                {
                    "title": "",
                    "url":  "vom-leben-zu-wenig-010.jpg"
                },
                {
                    "title": "",
                    "url":  "vom-leben-zu-wenig-011.jpg"
                },
                {
                    "title": "",
                    "url":  "vom-leben-zu-wenig-012.jpg"
                }
            ]
        }
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "4",
        "position": "",
        "name": "Burning Money",
        "group": ["editing"],
        "filter": "fiction",
        "genre": "Kurzfilm",
        "length": "15 Min",
        "year": "2013",
        "tasks": ["Editor"],
        "description": "Die IZB hat das Geld abgeschafft und den Handel verboten. In dieser Welt treffen sich Wayne, Victor und Walter und schlagen sich durch Richtung Norden, um das Land zu verlassen.",
        "festivals": "",

        "links": {
            "link": {
                "title":  "Trailer ansehen",
                "url":    "https://vimeo.com/69037339",
                "type":   "video"
            }
        },
        "team": {
            "regie":    "Tim Weskamp",
            "camera":   "Tim Weskamp",
            "editing":  "",
            "producer": "",
            "cast":     ""
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "burning-money-001.jpg"
                },
                {
                    "title": "",
                    "url":  "burning-money-002.jpg"
                },
                {
                    "title": "",
                    "url":  "burning-money-003.jpg"
                },
                {
                    "title": "",
                    "url":  "burning-money-004.jpg"
                },
                {
                    "title": "",
                    "url":  "burning-money-005.jpg"
                },
                {
                    "title": "",
                    "url":  "burning-money-006.jpg"
                },
                {
                    "title": "",
                    "url":  "burning-money-007.jpg"
                }

            ]
        }
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    /*   {
          "id": "3",
          "position": "",
          "name": "Soundtracks and Trailermusic",
          "group": ["editing"],
          "filter": "dok",
          "genre": "Dokumentarfilm",
          "length": "22 Min",
          "year": "2018",
          "tasks": ["Editor"],
          "description": "",
          "festivals": "",

          "links": {
             "link": {
                "title":  "",
                "url":    "",
                "type":   ""
             }
          },
          "team": {
             "regie":    "Peter F. Ebbinghaus & Stephan Brosch",
             "camera":   "",
             "editing":  "",
             "producer": "",
             "cast":     "",
          },
          "images": {
             "image": [
                {
                   "title": "",
                   "url":  ""
                }
             ]
          }
       },*/

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "2",
        "position": "0",
        "name": "Einmal und nie wieder",
        "group": ["editing"],
        "filter": "fiction",
        "genre": "Kurzfilm",
        "length": "17 Min",
        "year": "2012",
        "tasks": ["Colorist"],
        "description": "Adele ist eine junge französische Regisseurin, die im Deutschland der 70iger Jahre versucht ihren nächsten Film umzusetzen. Auf der Suche nach Inspiration findet sie diese unverhofft in einer Affäre mit einem Fremden. Ihre Träume und Erlebnisse beginnen mit der Realität ihres Drehbuch fast undurchschaubar zu verschmelzen.",
        "festivals": "",

        "links": {
            "link": {
                "title":  "Kurzfilm ansehen",
                "url":    "https://vimeo.com/37114986",
                "type":   "video"
            }
        },
        "team": {
            "regie":    "Lilia Paul",
            "camera":   "Maciej Rolbiecki",
            "editing":  "",
            "producer": "Maciej Rolbiecki",
            "cast":     "Matthias Dietrich, Lily Deslys, Anne Eyer",
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "einmal-und-nie-wieder-001.jpg"
                },
                {
                    "title": "",
                    "url":  "einmal-und-nie-wieder-002.jpg"
                },
                {
                    "title": "",
                    "url":  "einmal-und-nie-wieder-003.jpg"
                },
                {
                    "title": "",
                    "url":  "einmal-und-nie-wieder-004.jpg"
                },
                {
                    "title": "",
                    "url":  "einmal-und-nie-wieder-005.jpg"
                },
                {
                    "title": "",
                    "url":  "einmal-und-nie-wieder-006.jpg"
                },
                {
                    "title": "",
                    "url":  "einmal-und-nie-wieder-007.jpg"
                },
                {
                    "title": "",
                    "url":  "einmal-und-nie-wieder-008.jpg"
                },
                {
                    "title": "",
                    "url":  "einmal-und-nie-wieder-009.jpg"
                },
                {
                    "title": "",
                    "url":  "einmal-und-nie-wieder-010.jpg"
                },
                {
                    "title": "",
                    "url":  "einmal-und-nie-wieder-011.jpg"
                }
            ]
        }
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "1",
        "position": "0",
        "name": "Panopticon",
        "group": ["editing"],
        "filter": "fiction",
        "genre": "Kurzfilm",
        "length": "20 Min",
        "year": "2011",
        "tasks": [""],
        "description": "Panopticon ist ein kritischer Kurzfilm zum Thema Überwachung. Nach Drehbuch und Regie von Tim Weskamp, Der Film enstand im Rahmen des Filmfestivals Düsseldorf ist ARTig.",
        "festivals": "Düsseldorf ist ARTig",

        "links": {
            "link": {
                "title":  "Trailer ansehen",
                "url":    "https://vimeo.com/32163402",
                "type":   "video"
            }
        },
        "team": {
            "regie":    "Tim Weskamp",
            "camera":   "Tim Weskamp",
            "editing":  "Robin Jünkersfeld, Dennis Hubens",
            "producer": "",
            "cast":     "Lucas Janson, Lilli Meinhardt, Zejhun Demirov"
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "panopticon-003.jpg"
                },
                {
                    "title": "",
                    "url":  "panopticon-002.jpg"
                },
                {
                    "title": "",
                    "url":  "panopticon-001.jpg"
                },
                {
                    "title": "",
                    "url":  "panopticon-004.jpg"
                },
                {
                    "title": "",
                    "url":  "panopticon-005.jpg"
                },
                {
                    "title": "",
                    "url":  "panopticon-006.jpg"
                },
                {
                    "title": "",
                    "url":  "panopticon-007.jpg"
                }
            ]
        }
    },

// - - - - - - - - - - - - - - - - - - - - - - - - - - - - //

    {
        "id": "0",
        "position": "0",
        "name": "Lügen haben müde Beine",
        "group": ["editing"],
        "filter": "fiction",
        "genre": "Kurzfilm",
        "length": "3 Min",
        "year": "2011",
        "tasks": ["Regie", "Kamera", "Editor"],
        "description": "Lügen haben müde Beine ist ein Kurzfilm der als Abschlussarbeit zur Mediengestalter Prüfung " +
            "entstanden ist. Vorgabe war das Thema 'Lügen' und die gewählte Länge von 3 Minuten exakt einzuhalten.",
        "festivals": "1.Platz Baden-Baden Award 2011",

        "links": {
            "link": {
                "title":  "Kurzfilm ansehen",
                "url":    "https://vimeo.com/66754503",
                "type":   "video"
            }
        },
        "team": {
            "regie":    "",
            "camera":   "",
            "editing":  "",
            "producer": "",
            "cast":     "Marcel Knöschens, Kristof Keller, Nico Schäffer, Ricarda Clark"
        },
        "images": {
            "image": [
                {
                    "title": "",
                    "url":  "luegen-haben-muede-beine-008.jpg"
                },
                {
                    "title": "",
                    "url":  "luegen-haben-muede-beine-002.jpg"
                },
                {
                    "title": "",
                    "url":  "luegen-haben-muede-beine-003.jpg"
                },
                {
                    "title": "",
                    "url":  "luegen-haben-muede-beine-004.jpg"
                },
                {
                    "title": "",
                    "url":  "luegen-haben-muede-beine-005.jpg"
                },
                {
                    "title": "",
                    "url":  "luegen-haben-muede-beine-006.jpg"
                },
                {
                    "title": "",
                    "url":  "luegen-haben-muede-beine-007.jpg"
                },
                {
                    "title": "",
                    "url":  "luegen-haben-muede-beine-001.jpg"
                }
            ]
        }
    }
]
